/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable no-use-before-define */
/* eslint-disable no-var */
/* eslint-disable block-scoped-var */
/* eslint-disable no-lonely-if */
/* eslint-disable import/no-unresolved */
/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */
// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from "enquire.js";
// detect if a device is mouseOnly, touchOnly, or hybrid => http://detect-it.rafrex.com/
import detectIt from "detect-it";
import Flickity from "flickity";
// import PredictiveSearch from '@shopify/theme-predictive-search';
import { saveAs } from "file-saver";
import * as JSZip from "jszip";
import * as JSZipUtils from "jszip-utils";
import axios from "axios";

const customMethods = {
  data() {
    return {
      appsProductCollection: {
        products: [],
      },
      all_patterns: {
        collection: [],
        pagination: {},
        activeFilters: [],
      },
      search_results: {
        results: {},
        pagination: {},
      },
      collections_col: {
        collection: [],
        pagination: {},
        activeFilters: [],
      },
      productAddons: {
        products: [],
        selectedProduct: [],
        currentVariant: {},
        currentProduct: {},
        selectedVariant: [],
        totalValue: null,
      },
    };
  },

  methods: {
    _initCustomMethods() {
      app.__global();
      app.__redirectHulkApps();
      app.__getFromUrl();
      app.__appendPageDescription();
      if(typeof($('[data-current_template]').data('current_template')) == 'string') {
        if ($('[data-current_template]').data('current_template').includes('collection.service') ) {
          app.__newsletter();        
        }
      }
      
      app.__slideDownAnimation();
      app.__imageZoomOnClick(); // Open image in modal when clicking on image
      app.__featureSlide();
      app.__faqs();
      app.__mobileclick();
      app.__readmoreless(); // Service Page read more
      app.__reviewreadmoreless(); // normal product page review read more
      app.__closeCartDrawer();
      app.__counterAnimation();
      app.__whatsnewPage();
      app.__serviceOverallSearch();
      app.__searchPage();
      app.__packagePages();
      app.__partnersPage();
      app.__jobapplyform();
      app.__careers();
      app.__supportArticle();
      app.__appCompetition();
      app.__getArticleContent();
      app.__getViewPageLink();
      app.__locationPage();
      app.__appProduct();
      app.__appCollection();
      app.__addons();
      app.__downloadFolders();
      app.__patternFilter();
      app.__patternsProduct();
      app.__allPatterns();
      app.__patternsCaseStudy();
      app.__rechargrRecipesProduct();
      app.__hulkthemeProduct();
      app.__migrationCenterProduct();
      app.__serviceProduct();
      app.__serviceCollection();
      app.__serviceCustomQuoteForm();
      app.__custom_hulkcode();
      app.__productAddons();
      app._countArticleVote();
      // app.__replaceWord();
      app.__usecase();
      app.__moveExtraFaq();
    },

    __global() {
      // Noindex the URL which have /tag
      if (main_url.slice(main_url.length - 4) === "/tag") {
        // $("head").append('<meta name="robots" content="noindex,nofollow">');
      }
    
      // Open side menu tabs on hover instead of click
      $('.megamenu .megamenu-tab a[role="tab"]').on("mouseenter", function () {
        // $(this).trigger('click');
        $(this).tab("show");
      });

      $('.megamenu .megamenu-tab a[role="tab"]').on("shown.bs.tab", (e) => {
        var target = $(e.relatedTarget).attr("href");
        $(target).removeClass("active");
      });

      // Tab activation based on the tab hash in the URL of the theme integration article
      $('.theme-inte .nav-tabs a[data-toggle="tab"]').on(
        "shown.bs.tab",
        (e) => {
          history.pushState({}, "", e.target.hash);
        }
      );

      var hash = document.location.hash;
      var prefix = "tab_";
      if (hash) {
        $(`.theme-inte .nav-tabs a[href="${hash.replace(prefix, "")}"]`).tab(
          "show"
        );
      }

      // $('.brand-slider-section .flickity-viewport').height($('.brand-slider-section .flickity-viewport').outerHeight() + 25);
      // $('.brand-slider-section .flickity-viewport').height($('.brand-slider-section .flickity-viewport').outerHeight() + 25);

      setTimeout(() => {
        $("#terms-agree").on("change", function () {
          if ($(this).prop("checked") === true) {
            $('#checkout-form [name="checkout"]').removeAttr("disabled");
          } else {
            $('#checkout-form [name="checkout"]').attr("disabled", "disabled");
          }
        });
      }, 1000);

      $("*").each(function () {
        if ($(this).is("img")) {
          const alt = $(this).attr("alt");
          // eslint-disable-next-line eqeqeq
          alt == undefined || alt == ""
            ? $(this).attr("alt", "Shopify - Help")
            : $(this).attr("alt", `Shopify - ${alt}`);
        }
      });

      $("a").each(function () {
        if (
          $(this).attr("href") ===
          "https://dev-master-marketer.hulkapps.com/" ||
          $(this).attr("href") === "https://dev-master-marketer.hulkapps.com" ||
          $(this).attr("href") ===
          "https://productoption-staging.hulkapps.com/" ||
          $(this).attr("href") ===
          "https://productoption-staging.hulkapps.com" ||
          $(this).attr("href") ===
          "https://contactform.hulkapps.com/corepage/contact?id=562308a12aaa260388815b" ||
          $(this).attr("href") ===
          "https://contactform.hulkapps.com/corepage/contact?id=6c2ddd30337b087b94adfc" ||
          $(this).attr("href") ===
          "https://contactform.hulkapps.com/corepage/contact?id=a665972adde55882d5cef1"
        ) {
          $(this).attr("href", "/");
        }
      });

      // Replaced the e-commerce/ecommerce word to ecommerce
      // $('body').html($('body').html().replace('e-commerce', 'ecommerce'));
      // $('body').html($('body').html().replace('ecommerce', 'ecommerce'));
      // $('body').children().each(function() {
      //   $(this).html($(this).html().replace('e-commerce','eCommerce'));
      //   $(this).html($(this).html().replace('ecommerce','eCommerce'));
      // });

      $("a.mini-series-click").off("click");

      // if ($('body .sub-menu').length <= 0 && $('body .mega-menu').length <= 0) {
      //   $('body').addClass('search-top');
      // }
      $(".calendly-popup").on("click", function (event) {
        const cal_link = $(this).attr("data-calendly-url");
        if (cal_link) {
          app.__calendlyPopup(event, cal_link);
        }
      });

      $(".pricing-modal-popup").on("click", (event) => {
        app.__modalPopup(event);
      });

      $(".service-modal-popup").on("click", (event) => {
        app.__modalPopup(event);
      });

      $(".animate-section").on("click", function (event) {
        event.preventDefault();
        let animate_section = "";
        if ($(this).attr("data-animate-section")) {
          if (
            $(this)
              .attr("data-animate-section")
              .indexOf("#") > -1
          ) {
            animate_section = $(this).attr("data-animate-section");
          } else {
            animate_section = `.${$(this).attr("data-animate-section")}`;
          }
        }
        let animate_top = 0;
        if ($(this).attr("data-animate-top")) {
          animate_top = $(this).attr("data-animate-top");
        }
        app._animateToSection(animate_section, animate_top, event);
      });

      $(".modalpopup-click").on("click", (event) => {
        app.__modalPopup(event);
      });

      // if ($('[blog-other-data]').length > 0) {
      //   console.log('called inside mini');
      //   const all_blogs_data = $('[blog-other-data]').html();
      //   const all_blogs_data_2 = $('[blog-other-data-2]').html();
      //   $('[data-blogs-info]').append(all_blogs_data_2);
      //   $('[data-blogs-info]').append(all_blogs_data);
      // }

      // Check where this has been used
      const SliderOuterWidth = function () {
        const siteWidth = $(".container").outerWidth();
        const CarouselCell = 4;
        const CarouselCellWidth = siteWidth / CarouselCell;
        const win = $(this);
        if (win.width() < 1199) {
          $(".hero-slider .carousel-cell").css("width", "100%");
        } else {
          $(".hero-slider .carousel-cell").css("width", CarouselCellWidth);
        }

        if ($("[data-custom-flickity]").length > 0) {
          if (matchMedia("screen and (max-width: 1200px)").matches) {
            const $carousel1 = $("[data-custom-flickity]");
            const options1 = {
              adaptiveHeight: true,
              percentPosition: false,
              cellAlign: "left",
              wrapAround: false,
              freeScroll: false,
              prevNextButtons: false,
              pageDots: false,
              lazyLoad: 1,
              groupCells: "100%",
            };
            const flkty1 = new Flickity($carousel1[0], options1);
          } else {
            const $carousel1 = $("[data-custom-flickity]");
            const options1 = {
              adaptiveHeight: true,
              percentPosition: false,
              cellAlign: "center",
              wrapAround: false,
              freeScroll: false,
              prevNextButtons: false,
              pageDots: false,
              lazyLoad: 1,
              groupCells: 4,
            };
            const flkty1 = new Flickity($carousel1[0], options1);
          }
        }
      };

      $(document).ready(SliderOuterWidth);
      $(window).resize(SliderOuterWidth);

      // Check where this has been used
      $("[data-service-tooltip]").tooltip({
        placement: "bottom",
      });

      $("select.coll-filter").niceSelect();
      // const url = window.location.href;
      // const url_arr = url.split('?');
      // if (url_arr) {
      //   if (url_arr.length > 1) {
      //     const job_loc = url_arr[1].split('&');
      // console.log('called 1', job_loc);
      //     if (job_loc & job_loc.length >= 2) {
      //       console.log('called 2');
      //       const jobarr = job_loc[0].split('=');
      //       const locarr = job_loc[1].split('=');
      //       let job_post, location;
      //       if (jobarr[0] === 'job_post') {
      //         console.log('called job');
      //         job_post = jobarr[1].replace(/%20/g, ' ');
      //         $('#job-apply-form [name=Job Post]').val(job_post);
      //       }
      //       if  (locarr[0] === 'location') {
      //         console.log('called loc');
      //         location = locarr[1].replace(/%20/g, ' ');
      //         $('#job-apply-form [name=Location]').val(location);
      //       }
      //     }
      //   }
      // }

      // To show which link of main menu is active
      $(".main-menu .nav-item .tab-pane .active")
        .parents(".nav-item")
        .find(".nav-link:first-child")
        .addClass("active");

      // Check where this has been used
      // $('#hulkapps-partner-program').find('nav').removeClass('header-white');
      // $('[data-toggle="collapse"]').click(function(){
      // });
      // $('.collapse').collapse('toggle');

      // $(document).on('click', '#faq [data-toggle="collapse"]', function() {
      //   console.log('FAQ accordion');

      //   const target = $(this).data('target');
      //   $('#faq .collapse').collapse('hide');
      //   $(target).toggleClass('show');
      //   // $(target).collapse('show');
      //   // $(this).toggleClass('collapsed');
      // });

      // $('#faq .collapse').on('shown.bs.collapse', function() {
      //   $(this).parent().find('.ion-ios-arrow-down')
      //     .removeClass('ion-ios-arrow-down')
      //     .addClass('ion-ios-arrow-up');
      // }).on('hidden.bs.collapse', function() {
      //   $(this).parent().find('.ion-ios-arrow-up')
      //     .removeClass('ion-ios-arrow-up')
      //     .addClass('ion-ios-arrow-down');
      // });

      // $(document).on('click', '#accordion [data-toggle="collapse"]', function(e) {
      //   e.preventDefault();
      //   if ($(this).hasClass('collapsed')) {
      //     const target = $(this).data('target');
      //     $('#faq .collapse').collapse('hide');
      //     $('#accrodion .collapse').collapse('hide');
      //     $(target).toggleClass('show');
      //   }
      // });

      // $('#accordion .collapse').on('shown.bs.collapse', function() {
      //   $(this).parent().find('.ion-plus-round')
      //     .removeClass('ion-plus-round')
      //     .addClass('ion-minus-round');

      // }).on('hidden.bs.collapse', function() {
      //   $(this).parent().find('.ion-minus-round')
      //     .removeClass('ion-minus-round')
      //     .addClass('ion-plus-round');
      // });

      // $(document).on('click', '.article-tab-content .content-info .panel-group:not(#accordion) [data-toggle="collapse"]', function(e) {
      //   e.preventDefault();
      //   $(this).parents('.panel').siblings('.panel')
      //     .find('.collapse')
      //     .collapse('hide');
      //   if ($(this).hasClass('collapsed')) {
      //     let target;
      //     // eslint-disable-next-line eqeqeq
      //     if ($(this).data('target') && $(this).data('target') != undefined) {
      //       target = $(this).data('target');
      //     } else {
      //       target = $(this).attr('href');
      //     }
      //     $(target).toggleClass('show');
      //   }
      // });

      $(window).scroll(() => {
        // To set sidebar  position on the scroll of the mini-series articles
        const scroll = $(window).scrollTop();
        if (scroll >= 750) {
          $("body").addClass("sticky-bar");
        } else {
          $("body").removeClass("sticky-bar");
        }
      });

      // setTimeout(() => {
      //   $('.cart_item_count').removeClass('d-none');
      // }, 700);

      const youtube = document.querySelectorAll(".youtube");
      for (let i = 0; i < youtube.length; i++) {
        const youtubeSrc = $(".youtube").data("poster");
        const source = youtubeSrc;

        const image = new Image();
        image.src = source;
        image.className = "img-fluid";
        image.setAttribute("alt", "Video tumbnail");

        image.addEventListener(
          "load",
          (function () {
            youtube[i].appendChild(image);
          })(i)
        );
        youtube[i].addEventListener("click", function () {
          const data_embed = $(this).attr("data-embed");
          const data_embed_arr = data_embed.split("/");
          const embed_id = data_embed_arr[data_embed_arr.length - 1];

          const iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("title", "App video");
          iframe.setAttribute(
            "src",
            `https://www.youtube.com/embed/${this.dataset.embed}?rel=0&showinfo=0&autoplay=1`
          );

          $(this)
            .parent()
            .addClass("embed-responsive");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      }

      if ($("body").find(".wow").length > 0) {
        new WOW().init();
      }
    },

    __redirectHulkApps() {
      var search_url = document.URL;
      if (search_url.includes("fromplanetx")) {
        $("#hulkapps-popup").modal("show");
        $(".btn-close").on("click", () => {
          $("#hulkapps-popup").modal("hide");
        });
      } else {
        $("#hulkapps-popup").modal("hide");
      }
    },

    __getFromUrl() {
      const $url = window.location.href.split("#");
      const targetUrl = $url[1];
      if ($url[1]) {
        $("[data-toggle]").each(function (index, element) {
          const $this = $(this);
          const attr_target = $(this).attr("data-target");
          if (
            typeof attr_target !== typeof undefined &&
            attr_target !== false
          ) {
            const liTarget = $(this)
              .attr("data-target")
              .replace("#", "");

            if (targetUrl === liTarget) {
              $this.trigger("click");
            } else {
              $(".list-indexing").addClass("d-none");
              $(".tab-content-list").removeClass("d-none");

              const targetUrl_hash = `#${targetUrl}`;
              const $tab_indexing_target = $(
                `.tab-content-list .tab-indexing li a[href="#${targetUrl}"]`
              );
              if ($(window).width() >= 992) {
                app._supportIndexingcontent(
                  targetUrl_hash,
                  $tab_indexing_target
                );
              } else {
                $(".tab-indexing a")
                  .addClass("text-black")
                  .removeClass("text-success");
              }
            }
          }
        });
      }

      // Check how much has been used from this
      $(".install_btn").on("click", function (e) {
        const targetUrl = $(this).attr("data-target");
        $(".po_pro_tab .nav-link").each(function () {
          const $this = $(this);
          const liTarget = $(this).attr("data-target");
          if (targetUrl === liTarget) {
            $this.tab("show");
          }
        });
        
        app._animateToSection(animate_to, 0, e);
        // $('html, body').animate({ scrollTop: animate_to }, 'slow');
      });

      //header click
      $(".app-sub-menu li").each((item,val) => {
        let data_id = $(val).find('a').attr('href');
        console.log(data_id);
        console.log($(data_id).length);
        if ($(data_id).length <= 0){
          console.log($(val));
          $(val).addClass('d-none');
        }
      });
      $(".app-sub-menu li a").on("click", function (e) {
        app._animateToSection(animate_to, 0, e);
      });
     
    },

    __appendPageDescription() {
      $(".product-desc-1").append($(".description-1").removeClass("d-none"));
      $(".product-desc-2").append($(".description-2").removeClass("d-none"));
      $(".product-desc-image").append(
        $(".description-image").removeClass("d-none")
      );
      if ($(window).width() < 992) {
        $(".product-desc-1").append($(".more-desc"));
      }
      $(".last-section").append(
        $(".content-last-section").removeClass("d-none")
      );
      $(".package").append($(".more-packages").show());
      if ($("body #job-list").length > 0) {
        $(".job_block").each(function (index, item) {
          $(this)
            .find(".vac")
            .append(
              $(this)
                .find(".article-desc")
                .find(".vacancies")
                .text()
            );
          $(this)
            .find(".exp")
            .append(
              $(this)
                .find(".article-desc")
                .find(".experience")
                .text()
            );
        });
        $(".job-search").each(function (index, item) {
          $(this)
            .find(".vac")
            .append(
              $(this)
                .find(".article-disc")
                .find(".vacancies")
                .text()
            );
          $(this)
            .find(".exp")
            .append(
              $(this)
                .find(".article-disc")
                .find(".experience")
                .text()
            );
        });
      }
      if ($("body #job-details").length > 0) {
        $(".department").append($(".dept").show());
        $(".loc").append($(".location").show());
        $(".job").append($(".job-type").show());
        $(".exp").append($(".experience").show());
        $(".position-overview p").text(
          $(".position-overview")
            .next("p")
            .text()
        );
      }
    },

    __newsletter() {
  
      $(window).scroll(() => {
        // Show newsletter popup on the index page
        if (
          $("body").hasClass("template-index") ||
          $("body .index-page").length > 0
        ) {
          if (
            $(window).scrollTop() + $(window).height() ===
            $(document).height()
          ) {
            // if (sessionStorage.getItem("serviceNewsletterPopup") !== "false") {
            //   app._toggleNewsletterPopup();
            // }
          }
        } else if ($("body .service-collection").length > 0) {
          // Show scroll to top arrow
          if ($(window).scrollTop() > 20) {
            $(".scroll-to-top").removeClass("d-none");
          } else {
            $(".scroll-to-top").addClass("d-none");
          }
        } else if ($("body .services-sitemap").length > 0) {
          // Load more funtionality on the services sitemap page
          if (
            $(".load-more").length > 0 &&
            $(window).scrollTop() >=
            $(".load-more").position().top -
            $(".services-sitemap").attr("data-minus-scroll")
          ) {
            $(".load-more").removeClass("load-more");
            $(".see-more-results").trigger("click");
          }
        }
      });
      
    },

    __slideDownAnimation() {
      $(".slide-down").on("click", function () {
        const tar = $(this).attr("href");
        $("html, body").animate(
          {
            scrollTop: $(tar).offset().top - 160,
          },
          1000
        );
      });

      $(document).on("click", ".slide-down-minus", function () {
        const tar_href = $(this).attr("href");
        
        $(this).closest('.nav-item').siblings().find('.slide-down-minus.active').removeClass('active');
        $(this).addClass('active');
        $("html, body").animate(
          {
            scrollTop: $(tar_href).offset().top - 150,
          },
          1000
        );
      });
    },

    __imageZoomOnClick() {
      // Adding image-zoom classes for the zoom functionlaity
      $(".article-body img").addClass("image-zoom");

      // Adding image-zoom classes for the zoom functionlaity
      $(".article-content img")
        .not(".edit_preview")
        .addClass("image-zoom");

      setTimeout(() => {
        // Adding image-zoom classes for the zoom functionlaity
        $("[blog-other-data-2] img").addClass("image-zoom");
        $("[data-blogs-info] img").addClass("image-zoom");

        $(".image-zoom").each(function (index, element) {
          const image = $(this).attr("src");
          let image_replaced;
          if (image.indexOf("_100x") > 0) {
            image_replaced = image.replace("_100x", "");
          } else if (image.indexOf("_pico") > 0) {
            image_replaced = image.replace("_pico", "");
          } else {
            image_replaced = image;
          }
          $(this)
            .not(".edit_preview")
            .on("click", () => {
              $(".imagepreview").attr("src", image_replaced);
              $("#imagemodal").modal("show");
              $(".site-header").css("z-index", "999");
            });
        });
      }, 1000);
    },

    __featureSlide() {
      // Check how much has been used from this
      const myVar = setInterval(myTimer, 3000);

      function myTimer() {
        $(".feature-thumb .item.active")
          .next()
          .addClass("active")
          .siblings()
          .removeClass("active");
        $(".feature-thumb .item:last-child.active")
          .first()
          .addClass("active")
          .siblings()
          .removeClass("active");
        $(`#${$(".feature-thumb .item.active").attr("data-id")}`)
          .next()
          .addClass("active")
          .siblings()
          .removeClass("active");
      }

      $(".feature-thumb .item").mouseenter(function (e) {
        event.preventDefault();
        setTimeout(() => {
          clearInterval(myVar);
        }, 1000);
        $(this).fadeIn(5000, () => {
          // $(this).addClass("active");
        });
      });

      $(".feature-thumb .item:first").addClass("active");

      let activeDiv = 1;
      let activeD = 1;
      showDiv(activeDiv);
      showD(activeD);
      const timer = setInterval(changeDiv, 3000);

      function changeDiv() {
        activeDiv++;
        activeD++;
        if (activeDiv === 5) {
          activeDiv = 1;
        }
        if (activeD === 4) {
          activeD = 1;
        }
        showDiv(activeDiv);
        showD(activeD);
      }

      function showDiv(num) {
        $(".slide-wrapper .slide-div").hide();
        $(".content-slide-wrap .content-slide-child").removeClass("active");
        $(`#trigger-${num}`).fadeIn();
      }

      function showD(numb) {
        $(`#triggers-${numb}`).fadeIn();
      }
    },

    __faqs() {
      // Check where this has been used
      $("[data-target-button]").click(function () {
        const activeClass = "active";
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .parent()
            .siblings()
            .find(`.${activeClass}`)
            .removeClass(activeClass);
        } else {
          $(this).addClass("active");
          $(this)
            .parent()
            .siblings()
            .find(`.${activeClass}`)
            .removeClass(activeClass);
        }
        if ($(this).hasClass("active")) {
          $(this)
            .find("h5 i")
            .removeClass("ion-ios-arrow-down")
            .addClass("ion-ios-arrow-up");
          $(this)
            .parent()
            .siblings()
            .find("h5 i")
            .removeClass("ion-ios-arrow-up")
            .addClass("ion-ios-arrow-down");
        } else {
          $(this)
            .find("h5 i")
            .removeClass("ion-ios-arrow-up")
            .addClass("ion-ios-arrow-down");
        }
      });
    },

    __mobileclick() {
      // Check how much has been used from this
      $(".bitmoji_sm").each(function () {
        const $this = $(this);
        let id = "";
        $this.on("click", (e) => {
          id = $this.attr("id");
          e.preventDefault();
          $(".bitmoji-description, .bitmoji").each(function () {
            const data_item_id = $(this).data("item-id");
            if (id === data_item_id) {
              $(this)
                .addClass("active")
                .siblings()
                .removeClass("active");
            }
          });
          $(".review-desc").each(function () {
            const data_item_id = $(this).data("item-id");
            if (id === data_item_id) {
              $(this)
                .addClass("active")
                .siblings()
                .removeClass("active");
            }
          });
        });
      });
    },

    // Read full/short for the app/service/HT collection
    __readmoreless() {
      // Set height of the Service collection page description according to the image
      if (".collection-image".length > 0) {
        const collection_img_height = parseFloat(
          $(".collection-image").height()
        );

        if (collection_img_height > $(".truncate.more").height()) {
          $(".collection-page .readcontent").addClass("d-none");
        }
        const line_height_details = 15;
        const collection_img_height_dvd =
          collection_img_height / line_height_details;
        const collection_image_rounded =
          collection_img_height_dvd.toFixed(0) * line_height_details;
        $(".truncate")
          .height(collection_image_rounded)
          .css({
            // eslint-disable-next-line quote-props
            overflow: "hidden",
          });
      }

      $(".readcontent").each(function (index, item) {
        $(this).on("click", function (e) {
          e.preventDefault();
          if ($(this).siblings(".more-content").length > 0) {
            if ($(this).text() === "more") {
              $(this)
                .siblings(".more-content")
                .removeClass("d-none");
              $(this).text("less");
            } else {
              $(this)
                .siblings(".more-content")
                .addClass("d-none");
              $(this).text("more");
            }
          } else {
            if (
              $(this)
                .text()
                .toLowerCase() === "full description" ||
              $(this).text() === "Read more"
            ) {
              $("html, body").animate(
                {
                  scrollTop: $(this).offset().top - 120,
                },
                1000
              );
              $(this).text("Short description");
            } else {
              $(this).text("Full description");
            }
            if (
              $(this)
                .parent()
                .siblings(".more").length > 0
            ) {
              $(this)
                .parent()
                .siblings(".more")
                .toggleClass("h-auto");
              $(this)
                .parent()
                .siblings(".more")
                .toggleClass("d-inline");
              if ($(window).width() < 992) {
                $(".product-desc-2").removeClass("d-none");
              }
            } else {
              $(this)
                .parent()
                .siblings(".product-desc-2")
                .toggleClass("d-none");
            }
          }
        });
      });
      $('.moreless-button').click(function() {
        $('.moretext').slideToggle();
        if ($('.moreless-button').text() == "View More Features") {
          $(this).text("View Less Features")
        } else {
          $(this).text("View More Features")
        }
      });

      // $('.pricingless-button').click(function(event) {
      //   var pricing = event.target.closest('[data-readmore]').previousElementSibling;
      //   event.preventDefault();
      //   $(pricing).slideToggle();
      //   var $this = $(this);
      //   if ($this.text() == "Read More") {
      //     $(this).text("Read Less")
      //   } else {
      //     $(this).text("Read More")
      //   }
      // });


      $('.pricingless-button').click(function() {
        $('.morepricing').slideToggle();
        let readmore = $('.pricingless-button').text();
        var incStr = readmore.includes("View Full Feature Comparison");
        if (incStr) {
          $('.pricingless-button').text("View Less Feature Comparison")
        } else {
          $('.pricingless-button').text("View Full Feature Comparison")
        }
      });


      $('.moreless-intigration').click(function() {
        $('.more-intigration').slideToggle();
        if ($('.moreless-intigration').text() == "View More Integrations") {
          $(this).text("View Less Integrations")
        } else {
          $(this).text("View More Integrations")
        }
      });

      $(window).scroll(function() {
        if ($(this).scrollTop() > 300){  
            $('.button__sticky_section').addClass("button__sticky_show");
          }
          else{
            $('.button__sticky_section').removeClass("button__sticky_show");
          }
        });
    },

    __reviewreadmoreless() {
      // $('body').on('click', '.reviewcontent', function(e) {
      //   e.preventDefault();
      //   if ($(this).text() === 'Read more') {
      //     $(this).text('Read less');
      //   } else {
      //     $(this).text('Read more');
      //   }
      //   $(this).parent().siblings('.review-readmore')
      //     .toggleClass('h-auto');
      // });
    },

    __closeCartDrawer() {
      $(document).on("click", (e) => {
        if (app.isCartDrawerOpen) {
          if (
            $(e.target).closest(".navbar").length === 0 &&
            $(e.target).closest(".cart-drawer").length === 0 &&
            $(e.target).closest(".plan-section .btn").length === 0 &&
            $(e.target).closest(".addtocart").length === 0
          ) {
            app.isCartDrawerOpen = false;
            app._unlockScroll();
          }
        }
      });
    },

    __counterAnimation() {
      //  Counter Animation Javascript DO NOT DELETE THIS
      setTimeout(() => {
        const stats = document.querySelectorAll(".counter");
        stats.forEach((stat) => {
          // pattern used to seperate input number from html into an array of numbers and non numbers. EX $65.3M -> ["$65.3M", "$", "65", ".", "3", "M"]
          const patt = /(\D+)?(\d+)(\D+)?(\d+)?(\D+)?/;
          const time = 0;
          let result = [...patt.exec(stat.textContent)];
          let fresh = true;
          let ticks;

          // Remove first full match from result array (we dont need the full match, just the individual match groups).
          result.shift();
          // Remove undefined values from result array where they didnt have a match in one of the optional regex groups
          result = result.filter((res) => res != null);

          while (stat.firstChild) {
            stat.removeChild(stat.firstChild);
          }

          for (const res of result) {
            if (isNaN(res)) {
              stat.insertAdjacentHTML("beforeend", `<span>${res}</span>`);
            } else {
              for (let i = 0; i < res.length; i++) {
                stat.insertAdjacentHTML(
                  "beforeend",
                  `<span data-value="${res[i]}">
                    <span>0</span>
                    ${Array(parseInt(res[i]) + 1)
                    .join(0)
                    .split(0)
                    .map(
                      (x, j) => `
                      <span>${j}</span>
                    `
                    )
                    .join("")}
                  </span>`
                );
              }
            }
          }

          ticks = [...stat.querySelectorAll("span[data-value]")];

          const activate = () => {
            const top = stat.getBoundingClientRect().top;
            const offset = window.innerHeight * 0.9;

            setTimeout(() => {
              fresh = false;
            }, time);

            if (top < offset) {
              setTimeout(
                () => {
                  for (const tick of ticks) {
                    const dist = parseInt(tick.getAttribute("data-value")) + 1;
                    tick.style.transform = `translateY(-${dist * 100}%)`;
                  }
                },
                fresh ? time : 0
              );
              window.removeEventListener("scroll", activate);
            }
          };
          window.addEventListener("scroll", activate);
          activate();
        });
      }, 100);
    },

    __whatsnewPage() {
      const list = ".changelog-list";
      const hover_div = ".hover-div-changelog";
      const article_hover = ".article-hover";
      const opacity_hide = "opacity-hide";

      // Hide/show that small popup type when click on changelog boxes
      $(article_hover).on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass(opacity_hide);
        $(this)
          .siblings(hover_div)
          .toggleClass(opacity_hide);
        $(this)
          .parents(list)
          .siblings()
          .find(hover_div)
          .addClass(opacity_hide);
        $(this)
          .parents(list)
          .siblings()
          .find(article_hover)
          .removeClass(opacity_hide);
      });

      // Hide that small popup type when click on body outside the div
      $("body").on("click", (e) => {
        if ($(e.target).parents(list).length === 0) {
          $(hover_div).addClass(opacity_hide);
          $(article_hover).removeClass(opacity_hide);
        }
      });

      // show some content of description in the small popup
      $(".changelog-list").each(function (index, item) {
        const $from_replace = $(this).find(".art-content");
        const $to_replace = $(this).find(".no-changelog-content");

        if ($from_replace.find(".changelog-content").length > 0) {
          $(this)
            .find(".version-no")
            .text($from_replace.find("h5:first").html());
          $to_replace.html(
            $from_replace
              .find("ul:first li:first")
              .text()
              .substr(0, 105)
          );
        } else {
          $(this)
            .find(".version-no")
            .addClass("d-none");
          $(this)
            .find(".no-changelog-content")
            .html($from_replace.find(".no-changelog").text());
        }
      });
    },

    __serviceOverallSearch() {
      const shopURL_pro = $("body").data("shop-url");
      const searchPath_pro = `${shopURL_pro}/search?type=product&q=`;
      const type_url = $(".type_url").val();

      $(".search_form_services").on("submit", function (e) {
        const formValue_pro = $(this)
          .find('input[name="q"]')
          .val();
        const searchText1_pro = $(this)
          .find("#searchtext1")
          .val();
        const cleanFormValue_pro = encodeURI(formValue_pro);
        e.preventDefault();
        if (cleanFormValue_pro == null) {
          window.location.href = "/search";
        } else if (searchText1_pro && searchText1_pro !== "") {
          window.location.href = `${`${searchPath_pro +
            cleanFormValue_pro}*+${searchText1_pro}`}`;
        } else {
          window.location.href = `${searchPath_pro + cleanFormValue_pro}*`;
        }
      });

      $(".search_form_services").append(
        '<div class="search__results-wrapper position-absolute w-100 zindex-sticky"><ul class="pro_list"></ul></div>'
      );
      $(".search_form_services .pro_list").hide();
      $('.search_form_services input[name="q"]')
        .attr("autocomplete", "off")
        .bind("keyup change", function () {
          const term_pro = jQuery(this).val();
          const cleanTerm_pro = encodeURI(term_pro);
          const searchURL_pro = searchPath_pro + cleanTerm_pro;
          const $form_pro = jQuery(this).closest("form");
          const $resultsList_pro = $form_pro.find(".pro_list");

          if (term_pro.length >= 3) {
            const search_pro_pro = `${searchURL_pro}*&view=json`;
            // console.log('search_pro_pro', search_pro_pro);
            $.ajax({
              type: "GET",
              url: search_pro_pro,
              dataType: "json",
              success(data) {
                const get_Handles_pro = [];
                $resultsList_pro.empty();
                if (data.results_count === 0) {
                  $resultsList_pro.html(
                    `<li><span class="title">No results found for \`${term_pro}\`</span></li>`
                  );
                  $resultsList_pro.fadeIn(200);
                } else {
                  jQuery.each(data.results, (index, item) => {
                    // console.log('called');
                    if (item.object_type === "product") {
                      let product_type = "";
                      let not_product_type = "";
                      let not_product_tag = "";
                      if (type_url === "patterns_url") {
                        // console.log('clled if')
                        product_type = "patterns";
                        not_product_type = "pricing";
                      } else {
                        // console.log('called else')
                        not_product_tag = "search-hide-product";
                      }
                      // console.log(product_type, not_product_type, not_product_tag, item.tags.indexOf(not_product_tag))
                      if (
                        (product_type !== "" &&
                          item.product_type
                            .toLowerCase()
                            .indexOf(product_type) !== -1 &&
                          not_product_type !== "" &&
                          item.product_type
                            .toLowerCase()
                            .indexOf(not_product_type) === -1) ||
                        (not_product_tag !== "" &&
                          item.tags.indexOf(not_product_tag) === -1)
                      ) {
                        get_Handles_pro.push(item);
                      }
                    }
                  });

                  if (get_Handles_pro.length > 0) {
                    let item_count = 0;
                    if (get_Handles_pro.length > 5) {
                      item_count = 5;
                    } else {
                      item_count = get_Handles_pro.length;
                    }
                    for (let index = 0; index < item_count; index++) {
                      const item = get_Handles_pro[index];
                      const $link = jQuery("<a></a>").attr("href", item.url);
                      if (item.product_type.toLowerCase() == "patterns") {
                        $link.append(
                          `<div class="d-flex align-items-center"><div class="title py-2"><p class="title-color" data-toggle="tooltip" title="${item.title}"><b>${item.title}</b></p></div></div>`
                        );
                      } else {
                        // eslint-disable-next-line eqeqeq
                        if (item.thumbnail != "NULL") {
                          $link.append(
                            `<div class="d-flex align-items-center"><span class="thumbnail"><img src="${item.thumbnail}" alt="${item.title}" /></span><div class="title"><p class="title-color" data-toggle="tooltip" title="${item.title}"><b>${item.title}</b></p></div></div>`
                          );
                        }
                      }
                      $link.wrap(
                        `<li class="item-result${item.object_type}"></li>`
                      );
                      $resultsList_pro.append($link.parent());
                    }
                    $resultsList_pro.append(
                      `<li style="text-align:center"><span style="text-align:center"><a href="${searchURL_pro}">See all results (${get_Handles_pro.length})</a></span></li>`
                    );
                  } else {
                    $resultsList_pro.html(
                      `<li><span class="title">No results found for \`${term_pro}\`</span></li>`
                    );
                  }
                  $(".search_form_services .pro_list").show();
                  $resultsList_pro.fadeIn(200);
                }
              },
            });
          }
        });

      $(document).on("click", (e) => {
        if (app.isSearchLayerOpen) {
          if (
            $(e.target).closest(".navbar").length === 0 &&
            $(e.target).closest(".search-reveal").length === 0 &&
            $("body").find("search__results-wrapper").length <= 0 &&
            $(e.target).closest(".filter-close").length === 0
          ) {
            e.preventDefault();
            app.isSearchLayerOpen = false;
            app._unlockScroll();
            app.isOverlayVisible = false;
            $(".search-item").removeClass("search-open");
            $("body").removeClass("searchbar-open");
          } else {
            $(".search-item").toggleClass("search-open");
          }
        }
      });
    },

    __searchPage() {
      // Search functionality for the service collection/support pages
      const coll_handle = $(".coll_handle").data("collection-handle");
      var collection_products = {};

      const article_handle = $(".article_handle").data("article-handle");
      const $support = $(".support_url");
      const shopURL = $("body").data("shop-url");
      const $type_not_ele = $('[name="type"]').not(".type_url");
      const type_ele = $($type_not_ele)[0];
      const type_value = $(type_ele).val();
      // console.log(type_ele, $(type_ele), $(type_ele)[0], type_value)
      let searchPath;

      // console.log(coll_handle, article_handle, $support, type_value);
      // eslint-disable-next-line eqeqeq
      if (coll_handle != undefined) {
        // console.log('if first');
        searchPath = `${shopURL}/search?type=product&q=`;
        // eslint-disable-next-line eqeqeq
      } else if (article_handle != undefined || $support.length > 0) {
        // console.log('else if 1 first', article_handle, $support);
        searchPath = `${shopURL}/search?type=article&q=`;
      } else if (type_value != undefined) {
        // console.log('else if 2 first');
        // console.log('called if type_value', type_value)
        searchPath = `${shopURL}/search?type=${type_value}&q=`;
        // eslint-disable-next-line eqeqeq
      } else {
        // console.log('else first');
        searchPath = `${shopURL}/search?q=`;
      }

      $(".search_form, .blog_form, .support_form").on("submit", function (e) {
        const formValue = $(this)
          .find('input[name="q"]')
          .val();
        const searchText1 = $(this)
          .find("#searchtext1")
          .val();
        // console.log('type_value', type_value);
        const cleanFormValue = encodeURI(formValue);
        e.preventDefault();

        if (cleanFormValue == null) {
          // console.log('if');
          window.location.href = "/search";
        } else if (searchText1 && searchText1 !== "") {
          // console.log('else if')
          window.location.href = `${`${searchPath +
            cleanFormValue}*+${searchText1}`}`;
        } else {
          // console.log('else', searchPath, cleanFormValue)
          window.location.href = `${searchPath + cleanFormValue}*`;
        }
      });
      if (coll_handle != "" || coll_handle != undefined) {
        $.ajax({
          type: "GET",
          url: `/collections/${coll_handle}/products.json`,
          dataType: "json",
          success: function (resultData) {
            collection_products = resultData;
          },
        });
      }

      const $searchForms = jQuery(
        ".search_form,  #search-page form.search-page, #blog-search form.blog_form, #support_search form.support_form"
      ).each(function () {
        const $input = $(this).find('input[name="q"]');

        $(
          ".search_form, #search-page form.search-page, #blog-search form.blog_form, #blog-search.blog_form, #support_search form.support_form"
        ).append(
          '<div class="search__results-wrapper position-absolute w-100"><ul class="pro_list"></ul></div>'
        );
        $(this)
          .find(".pro_list")
          .hide();

        $input.attr("autocomplete", "off").bind("keyup change", function () {
          const term = jQuery(this).val();
          const cleanTerm = encodeURI(term);
          const searchURL = searchPath + cleanTerm;
          const $form = jQuery(this).closest("form");
          const $resultsList = $form.find(".pro_list");

          if (term.length >= 3) {
            const search_pro = `${searchURL}*&view=json`;
            $.ajax({
              type: "GET",
              url: search_pro,
              dataType: "json",
              success(data) {
                var get_Handles = [];
                $resultsList.empty();
                if (data.results_count === 0) {
                  // console.log('iffff')
                  $resultsList.html(
                    `<li><span class="title">No results found for \`${term}\`</span></li>`
                  );
                  $resultsList.fadeIn(200);
                } else {
                  // console.log('elsseeee')
                  jQuery.each(data.results, (index, item) => {
                    if ($support.length > 0) {
                      // eslint-disable-next-line eqeqeq
                      if (
                        item.object_type == "article" &&
                        $.inArray("support-articles", item.tags) != -1
                      ) {
                        get_Handles.push(item);
                      }
                    } else {
                      // eslint-disable-next-line no-lonely-if
                      if (item.object_type === "product") {
                        get_Handles = [];
                        for (const product of collection_products.products) {
                          if (JSON.stringify(product.tags).includes(term)) {
                            get_Handles.push(product);
                          }
                        }
                        const addon_type = "add-on";
                        if (coll_handle != undefined) {
                          for (let i = 0; i < item.collections.length; i++) {
                            // console.log(item.collections[i].handle, coll_handle, item.product_type.toLowerCase().indexOf(addon_type), item.tags.indexOf('search-hide-product'))
                            if (
                              item.collections[i].handle === coll_handle &&
                              item.tags.indexOf("search-hide-product") === -1
                            ) {
                              get_Handles.push(item);
                            }
                          }
                        } else if (
                          item.tags.indexOf("search-hide-product") === -1
                        ) {
                          get_Handles.push(item);
                        }
                        // eslint-disable-next-line eqeqeq
                      } else if (item.object_type == "article") {
                        const item_url = item.url;
                        if (item_url.indexOf(article_handle) > -1) {
                          get_Handles.push(item);
                        }
                      }
                    }
                  });
                  if (get_Handles.length > 0) {
                    let item_count = 0;
                    if (get_Handles.length > 5) {
                      item_count = 5;
                    } else {
                      item_count = get_Handles.length;
                    }
                    for (let index = 0; index < item_count; index++) {
                      const item = get_Handles[index];
                      var $link = "";
                      if (item.url != undefined) {
                        $link = jQuery("<a></a>").attr("href", item.url);
                        console.log(item.url, "$link");
                      } else {
                        $link = jQuery("<a></a>").attr(
                          "href",
                          `/products/${item.handle}`
                        );
                        console.log($link, "$link");
                      }

                      if (
                        item.object_type == "article" ||
                        item.object_type == "product"
                      ) {
                        $link.append(
                          `<div class="d-flex align-items-center"><div class="title py-2"><p class="title-color" data-toggle="tooltip" title="${item.title}"><b>${item.title}</b></p><p>${item.price}</p></div></div>`
                        );
                      } else {
                        if (item.thumbnail !== "NULL") {
                          $link.append(
                            `<div class="d-flex align-items-center"><span class="thumbnail"><img src="${item.images[0].src}" alt="${item.title}" /></span><div class="title"><p class="title-color" data-toggle="tooltip" title="${item.title}"><b>${item.title}</b></p><p>${item.variants[0].price}</p></div></div>`
                          );
                        } else if (item.images.length > 0) {
                          $link.append(
                            `<div class="d-flex align-items-center"><span class="thumbnail"><img src="${item.images[0].src}" alt="${item.title}" /></span><div class="title"><p class="title-color" data-toggle="tooltip" title="${item.title}"><b>${item.title}</b></p><p>${item.price}</p></div></div>`
                          );
                        }
                      }
                      $link.wrap(
                        `<li class="item-result${item.object_type}"></li>`
                      );
                      $resultsList.append($link.parent());
                    }
                    $resultsList.append(
                      `<li style="text-align:center"><span style="text-align:center"><a href="${searchURL}">See all results (${get_Handles.length})</a></span></li>`
                    );
                  } else {
                    $resultsList.html(
                      `<li><span class="title">No results found for \`${term}\`</span></li>`
                    );
                  }
                  $(this)
                    .find(".pro_list")
                    .show();
                  $resultsList.fadeIn(200);
                }
              },
            });
          }
        });
      });
      jQuery("body").bind("click", (e) => {
        if ($(e.target).closest(".bread-search").length === 0) {
          jQuery(".pro_list").hide();
        }
      });

      // $('[data-search-json]').each((ind, item) => {

      // let curr_loc = window.location.search.replace('?', '').split('&');
      // console.log(curr_loc)
      // curr_loc.forEach(function(ite, ind){
      // //let pro_type =
      // console.log(ite, ite.indexOf('product_type'));
      // if(ite.indexOf('product_type') >= 0){
      // console.log('yes');
      // let curr_pro_type = ite.split('=');
      // console.log(curr_pro_type[1]);
      // }
      // });

      // const searchItem = $('[data-search-json]').html();
      // const SearchsData = JSON.parse(searchItem);
      // console.log(SearchsData, SearchsData.results);
      // const curr_loc = window.location.q
      // app.search_results.results = SearchsData;
      // });
    },

    __packagePages() {
      // Hide the prev/next arrows if only 2 or less stories are there
      if ($(".support-merchant-stories .stories-wrap").length <= 2) {
        $(".support-merchant-stories .flickity-prev-next-button").hide();
      } else {
        $(".support-merchant-stories .flickity-prev-next-button").show();
      }

      // Check where this has been used
      // Can be removed in new guideline theme
      $(".author-logo .carousel-cell").each(function (index, item) {
        $(this).on("click", () => {
          $(".site-logo .carousel-cell")
            .eq(index)
            .find("img")
            .removeClass("d-none");
          $(".site-logo .carousel-cell")
            .eq(index)
            .siblings()
            .find("img")
            .addClass("d-none");
        });
      });
      $(".author_desc .flickity-prev-next-button").each(function (index, item) {
        $(this).on("click", () => {
          $(".site-logo .carousel-cell")
            .eq(index)
            .find("img")
            .removeClass("d-none");
          $(".site-logo .carousel-cell")
            .eq(index)
            .siblings()
            .find("img")
            .addClass("d-none");
        });
      });

      // Set the same height on the developement package page
      if ($("body .best-offer").length > 0) {
        app.__setDivSameHeight(".best-offer .package-div .card-body");
      }

      // Added FB form ID from the page content of the package pages
      $(".pricing-popup .pxFormGenerator").attr(
        "id",
        $(".pricing-modal-popup").attr("data-form-id")
      );
    },

    __partnersPage() {
      $(".view-all-list").on("click", function (e) {
        e.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $(this).offset().top - 120,
          },
          1000
        );
        if ($(this).siblings(".opportunity").length > 0) {
          $(this)
            .siblings(".opportunity")
            .find(".table-content")
            .find(".view-other-plans")
            .removeClass("d-none");
          $(this)
            .removeClass("d-lg-block")
            .addClass("d-none");
        } else {
          $(this)
            .parent()
            .siblings(".table-content")
            .find(".view-other-plans")
            .removeClass("d-none");
          $(this)
            .removeClass("d-block")
            .addClass("d-none");
        }
      });
    },

    __jobapplyform() {
      // To pre-set the job post and location on the career page/article
      const url = window.location.href;
      const url_arr = url.split("?");
      if (url_arr) {
        if (url_arr.length > 1) {
          const job_loc = url_arr[1].split("&");
          if (job_loc && job_loc.length >= 2) {
            const jobarr = job_loc[0].split("=");
            const locarr = job_loc[1].split("=");
            let job_post;
            let location;
            if (jobarr[0] === "job_post") {
              job_post = jobarr[1].replace(/%20/g, " ");
              $('.location-div [name="job_name_hidden"]').val(job_post);
            }
            if (locarr[0] === "location") {
              location = locarr[1].replace(/%20/g, " ");
              // $('#job-apply-form [name="Location"]').val(location);
              const location_val_arr = location.split("/");
              location_val_arr.forEach((item) => {
                $("#select-location").append(
                  `<option value=${item}>${item}</option>`
                );
              });
            }
            setTimeout(() => {
              const jobForm = document.getElementById(
                "frame__ZODjrNxiEk2vIdD4Ia-1g"
              );
              if (jobForm != null) {
                // eslint-disable-next-line shopify/jquery-dollar-sign-reference
                // jobForm.contentWindow.postMessage({jobPost: job_post, city: location, form_name: 'Job Application - Careers - new' }, 'https://formbuilder.hulkapps.com/corepage/customform?id=_ZODjrNxiEk2vIdD4Ia-1g');
              }
            }, 6000);
          }
        }
      }

      $(".location-div .btn-location").on("click", () => {
        const $location_el = $("#select-location");
        let form_name_val = "";
        let form_id = "";
        let location_val = "";
        const job_post_val = $('.location-div [name="job_name_hidden"]').val();
        $(".bih-form").addClass("d-none");
        $(".all-form").addClass("d-none");
        $(".location-div #location-msg").addClass("d-none");
        if ($location_el.val() === "") {
          $(".location-div #location-msg").removeClass("d-none");
        } else {
          // $('.location-div').addClass('d-none');
          if ($location_el.val() === "BiH") {
            $(".bih-form").removeClass("d-none");
            form_id = "FzPa-5WKY1XkV8XY8YwLLg";
            location_val = $location_el.val();
            form_name_val = "Job Application - Careers - BiH";
          } else {
            $(".all-form").removeClass("d-none");
            form_id = "_ZODjrNxiEk2vIdD4Ia-1g";
            location_val = $location_el.val();
            form_name_val = "Job Application - Careers - new";
          }

          // var refreshIntervalId = setInterval(function () {
          var new_frame = document.getElementById(`frame_${form_id}`);
          if (new_frame != null) {
            new_frame.contentWindow.postMessage(
              {
                jobPost: job_post_val,
                city: location_val,
                form_name: form_name_val,
              },
              `https://formbuilder.hulkapps.com/corepage/customform?id=${form_id}`
            );
            //  clearInterval(refreshIntervalId);
          }
          // }, 2000);
        }
      });
    },

    __careers() {
      $(".location a").on("click", function () {
        $(".location .badge").removeClass("active");
        $(this)
          .find(".badge")
          .addClass("active");
      });
      $(".position a").on("click", function () {
        $(".position .badge").removeClass("active");
        $(this)
          .find(".badge")
          .addClass("active");
      });

      // $(document).on('click', '.job_list', function() {
      //   $('#error').html('').hide();
      //   let select_location;
      //   let select_position;
      //   if ($(this).parents('.position').length > 0) {
      //     if ($(this).parents('.postion_location').siblings('.postion_location').find('.location').find('.active').length > 0) {
      //       select_position = $(this).find('span').attr('data-position');
      //       select_location = $(this).parents('.postion_location').siblings('.postion_location').find('.location').find('.active').attr('data-location');
      //     } else {
      //       $('#error').html("Please Select Location.").show();
      //     }
      //   } else if ($(this).parents('.location').length > 0) {
      //     if ($(this).parents('.postion_location').siblings('.postion_location').find('.position').find('.active').length > 0) {
      //       select_location = $(this).find('span').attr('data-location');
      //       select_position = $(this).parents('.postion_location').siblings('.postion_location').find('.position').find('.active').attr('data-position');
      //     } else {
      //       $('#error').html("Please Select Position.").show();
      //     }
      //   }
      //   const path_url = window.location.origin;
      //   const new_url = path_url + "/" + "blogs" + "/" + select_location + "/" + "tagged" + "/" + select_position;

      //   $.ajax({
      //     url: new_url,
      //     type: 'GET',
      //     beforeSend() {
      //       $('#loader').show();
      //     },
      //     success(data) {
      //       $('#loader').hide();
      //       let new_data = '';
      //       new_data = $(data).find('.list').html();
      //       $('.job-data').html(new_data);
      //       $('.job-search').each(function(index, item) {
      //         $(this).find('.vac').append($(this).find('.article-disc').find('.vacancies').text());
      //         $(this).find('.exp').append($(this).find('.article-disc').find('.experience').text());
      //       });
      //     },
      //     error(error) {
      //       if (error.status === 404) {
      //         $('#loader').hide();
      //       }
      //     },
      //   });

      // });

      setTimeout(() => {
        $(".job-search").each(function (index, item) {
          $(this)
            .find(".vac")
            .append(
              $(this)
                .find(".article-disc")
                .find(".vacancies")
                .text()
            );
          $(this)
            .find(".exp")
            .append(
              $(this)
                .find(".article-disc")
                .find(".experience")
                .text()
            );
        });
      }, 1000);
      $("#job_listing .checkbox-design input").on("click", (e) => {
        $(".location_all").addClass("d-none");
        $(".job-data").html("");
        const url_arr = [];
        const select_exp = $("input[name='experience']:checked").val();
        let exp_tag;
        let exp_tag_url = "";
        const exp_tag_arr = [];
        let exp_tag_final;
        exp_tag_arr.push(select_exp);
        exp_tag = select_exp.replace("experience_", "");
        const exp_arr_under = exp_tag.split("_");
        if (exp_arr_under.length > 0) {
          exp_tag_arr.push(`experience_${exp_arr_under[0]}`);
          if (exp_arr_under[0] !== "any") {
            exp_tag_arr.push(`experience_${exp_arr_under[0]}_plus`);
          }
          for (let i = exp_arr_under[0] - 1; i > 0; i--) {
            exp_tag_arr.push(`experience_${i}_plus`);
          }
          exp_tag_final = exp_tag_arr.filter(
            (x, i) => exp_tag_arr.indexOf(x) === i
          );
          exp_tag_final.forEach((element, index) => {
            if (exp_tag_url === "") {
              exp_tag_url = element;
            } else {
              exp_tag_url = `${exp_tag_url}+${element}`;
            }
          });
        }
        if (
          $('input[name="location"]:checked')
            .val()
            .indexOf("all") > -1
        ) {
          const pos_val = $("input[name='position']:checked").val();
          let loc_val;
          const page_url = `${window.location.origin +
            window.location.pathname}?location=all`;
          $("#location .addons-item").each(function (index, item) {
            loc_val = $(this)
              .find('input[name="location"]')
              .val();
            if (index !== 0) {
              url_arr.push(
                `${window.location.origin}/` +
                `blogs` +
                `/${loc_val}/` +
                `tagged` +
                `/${pos_val}+${exp_tag_url}`
              );
            }
          });
          history.pushState({}, "", page_url);
        }
        if (url_arr.length > 0) {
          url_arr.forEach((item, index) => {
            $.ajax({
              url: item,
              type: "GET",
              beforeSend() {
                $("#loader").removeClass("d-none");
                $("#no-vacancy").addClass("d-none");
                $(".job-data").hide();
              },
              success(data) {
                $("#no-vacancy").addClass("d-none");
                let new_data = "";
                new_data = $(data)
                  .find(".list")
                  .html();
                $(".job-data").append(new_data);
                $(".job-search").each(function (index, item) {
                  $(this)
                    .find(".vac")
                    .html(
                      $(this)
                        .find(".article-disc")
                        .find(".vacancies")
                        .text()
                    );
                  $(this)
                    .find(".exp")
                    .html(
                      $(this)
                        .find(".article-disc")
                        .find(".experience")
                        .text()
                    );
                });
                $(".job-data").show();
                $("#loader").addClass("d-none");
              },
              error(error) {
                if (error.status === 404) {
                  $(".job-data").html("");
                  if ($(".job-data .job-search").length <= 0) {
                    $("#no-vacancy").removeClass("d-none");
                  }
                  $("#loader").addClass("d-none");
                }
              },
            }).done(() => {
              if ($(".job-data .job-search").length <= 0) {
                $("#no-vacancy").removeClass("d-none");
              }
            });
          });
        } else {
          const select_location = $("input[name='location']:checked").val();
          const select_position = $("input[name='position']:checked").val();
          const path_url = window.location.origin;
          const first_word_location = select_location.split("-")[0];
          const page_url = `${path_url +
            window.location
              .pathname}?location=${first_word_location.toLowerCase()}`;
          const new_url =
            path_url +
            "/" +
            "blogs" +
            "/" +
            select_location +
            "/" +
            "tagged" +
            "/" +
            select_position +
            "+" +
            exp_tag_url;
          history.pushState({}, "", page_url);
          $.ajax({
            url: new_url,
            type: "GET",
            beforeSend() {
              $("#loader").removeClass("d-none");
              $(".job-data").hide();
              $("#no-vacancy").addClass("d-none");
            },
            success(data) {
              let new_data = "";
              new_data = $(data)
                .find(".list")
                .html();
              $(".job-data").html(new_data);
              if ($(".job-data .job-search").length <= 0) {
                $("#no-vacancy").removeClass("d-none");
              }
              $(".job-search").each(function (index, item) {
                $(this)
                  .find(".vac")
                  .append(
                    $(this)
                      .find(".article-disc")
                      .find(".vacancies")
                      .text()
                  );
                $(this)
                  .find(".exp")
                  .append(
                    $(this)
                      .find(".article-disc")
                      .find(".experience")
                      .text()
                  );
              });
              $("#loader").addClass("d-none");
              $(".job-data").show();
            },
            error(error) {
              if (error.status === 404) {
                $("#loader").addClass("d-none");
                $("#no-vacancy").removeClass("d-none");
              }
            },
          });
        }
      });
      const main_url = window.location.href;
      const main_url_ar = main_url.split("?");
      if (main_url_ar.length > 1) {
        const main_query = main_url_ar[1].split("=");
        if (main_query[0].toLowerCase() === "location") {
          $("#location .addons-item").each(function (index, item) {
            const loc_val = $(this)
              .find('input[name="location"]')
              .val();
            if (
              loc_val.toLowerCase().indexOf(main_query[1].toLowerCase()) !== -1
            ) {
              $(this)
                .find('input[name="location"]')
                .trigger("click");
            }
          });
        }
      }

      $(".career-job-search #search_job").val("");
      $(".career-job-search #search_location").val("");
      $(".career-job-search #search_btn").on("click", (e) => {
        e.preventDefault();
        const search_job = $(".career-job-search #search_job").val();
        const search_location = $(".career-job-search #search_location").val();
        $(".vacancy-list .table-responsive").removeClass("d-none");
        $(".vacancy-list .job-table-body tr").removeClass("d-none");
        $(".vacancy-list .no-job").addClass("d-none");
        if (search_job != "" || search_location != "") {
          $(".vacancy-list .job-table-body tr").each((index, item) => {
            let show_flag_job = false;
            let show_flag_location = false;
            if (search_job != undefined && search_job != "") {
              if (
                $(item)
                  .find("td:eq(0)")
                  .text()
                  .toLowerCase()
                  .indexOf(search_job.toLowerCase()) != -1
              ) {
                show_flag_job = true;
              }
            }
            if (search_location != undefined && search_location != "") {
              if (
                $(item)
                  .find("td:eq(1)")
                  .text()
                  .toLowerCase()
                  .indexOf(search_location.toLowerCase()) != -1
              ) {
                show_flag_location = true;
              }
            }
            if (
              search_job != undefined &&
              !show_flag_job &&
              search_location != undefined &&
              !show_flag_location
            ) {
              $(item).addClass(index);
              $(item).addClass("d-none");
            }
          });

          if (
            $(".vacancy-list .job-table-body tbody tr:not(.d-none)").length <= 0
          ) {
            $(".vacancy-list .table-responsive").addClass("d-none");
            $(".vacancy-list .no-job").removeClass("d-none");
          }
        } else {
          $(".vacancy-list .table-responsive").removeClass("d-none");
          $(".vacancy-list .job-table-body tr").removeClass("d-none");
          $(".vacancy-list .no-job").addClass("d-none");
        }
      });

      $(".no-job #all-positions").on("click", (e) => {
        e.preventDefault();
        $(".career-job-search #search_job").val("");
        $(".career-job-search #search_location").val("");
        $(".vacancy-list .table-responsive").removeClass("d-none");
        $(".vacancy-list .job-table-body tr").removeClass("d-none");
        $(".vacancy-list .no-job").addClass("d-none");
      });
    },

    __supportArticle() {
      // Added padding class via jquery which can be added manually
      $(".article-tab-content .content-info")
        .removeClass("pt-8")
        .addClass("pt-7");

      $(document).ready(() => {
        // For the support articles
        $(".view-example-btn").on("click", () => {
          $(".site-header").css("z-index", "999");
          $(".article-tab-content .content-info").show();
        });
        // $('.demo-modal').click(() => {
        //   $('.article-tab-content .content-info').show();
        //   $('.site-header').css('z-index', '');
        //   $('.demo-modal-overlay').removeClass('show');
        //   $("div[id^='inner_modal-'] .modal-content").click(() => {
        //     event.stopPropagation();
        //   });
        // });
      });

      // Show indexing and right side content section on click of list
      $(".list-indexing a").on("click", function () {
        const list_href = $(this).attr("href");
        if (list_href.indexOf("#") > -1) {
          // Set to check if redirects to the page/hash tag functionality
          $(".list-indexing").addClass("d-none");
          $(".tab-content-list").removeClass("d-none");
          $(".tab-content-list .tab-indexing li").each(function (index, item) {
            if (
              list_href ===
              $(this)
                .find("a")
                .attr("href")
            ) {
              $(this)
                .find("a")
                .trigger("click");
            }
          });
        }
      });

      // Show banner on the support articles
      $(".list-indexing #install-process").on("click", () => {
        $("#general-banner").css("display", "block");
        $("#mobile-banner").css("display", "none");
        $("#banner").css("display", "none");
      });
      $(".list-indexing #setup-process").on("click", () => {
        $("#general-banner").css("display", "none");
        $("#mobile-banner").css("display", "block");
      });

      if ($(window).width() < 992) {
        $(".article-tab-content .content-info").hide();
      }

      // Show/hide right side content on click of indexing
      $(".tab-content-list .tab-indexing li a")
        .not('[role="button"]')
        .on("click", function (event) {
          const target = $(this).attr("href");
          if ($(window).width() < 992) {
            $("#indexing_popup .modal-body .modal-art-content").html(
              $(`.article-content${target}`).html()
            );
            $("#indexing_popup").modal("show");
            // Change the position of helpful section at the end of the article content
            const $helpful_article_modal = $(".helpful-article").detach();
            $("#indexing_popup .modal-body .modal-art-helpful").append(
              $helpful_article_modal
            );
            $(".helpful-article").removeClass("d-none");
          } else {
            const animate_to = $(".mini-banner").height();

            app._supportIndexingcontent(target, $(this));
            $("html, body").animate(
              {
                scrollTop: $(".article-tab-content").offset().top - 120,
              },
              1000
            );
          }
        });

      if ($("body").find(".article-tab-list").length <= 0) {
        $(
          ".article-tab-content .tab-content-list .tab-indexing .tab-indexing li:first a"
        ).trigger("click");
      }
    },

    __appCompetition() {
      // Functionalities of the AC pages/blogs/articles
      $('.app-page a[href^="#"]').on("click", function (event) {
        $(".app-page li").removeClass("active");
        $(this)
          .parent()
          .addClass("active");
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var target = $(this.getAttribute("href"));
        if (target.length) {
          event.preventDefault();
          $("html, body")
            .stop()
            .animate(
              {
                scrollTop: target.offset().top - 90,
              },
              1000
            );
        }
      });
      $(".app-overview").each(function (index, value) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var a_ele = $(this)
          .find("p")
          .find("a");
        // eslint-disable-next-line indent-legacy
        $(this)
          .find("p")
          .html(
            $(this)
              .find("p")
              .html()
              .substring(0, 250)
          ); // number of characters
        $(this)
          .find("p")
          .append(" ")
          .append(a_ele[0]);
      });
      if (
        $("body").find(".competition-page").length > 0 ||
        $("body").find(".competition").length > 0
      ) {
        let comp_page;
        if ($("body").find(".competition-page").length > 0) {
          comp_page = ".competition-page ";
        } else {
          comp_page = ".competition ";
        }
        const mainNavLinks = document.querySelectorAll(
          `${comp_page}.info-list li a`
        );
        const mainSections = document.querySelectorAll(
          `${comp_page}#faq > div`
        );

        let lastId;
        const cur = [];

        window.addEventListener("scroll", () => {
          let fromTop;
          // let fromTop = window.scrollY - ($('.competition .first-section').outerHeight() + $('.navbar-main').outerHeight() - 30);
          if ($(`${comp_page}section:last .row:first > div p`).length > 0) {
            // For all other apps
            if (
              $(`${comp_page}section:last .row:first > div p`).height() > 120
            ) {
              fromTop =
                window.scrollY -
                ($(comp_page)
                  .find(".first-section")
                  .outerHeight() +
                  $(".navbar-main").outerHeight() +
                  80);
            } else {
              fromTop =
                window.scrollY -
                ($(comp_page)
                  .find(".first-section")
                  .outerHeight() +
                  $(".navbar-main").outerHeight() +
                  50);
            }
          } else {
            fromTop =
              window.scrollY -
              ($(comp_page)
                .find(".first-section")
                .outerHeight() -
                10); // For the divs where no paragraph content found
          }

          mainNavLinks.forEach((link) => {
            const section_ele = document.querySelector(link.hash);
            if (
              section_ele.offsetTop <= fromTop &&
              section_ele.offsetTop + section_ele.offsetHeight > fromTop
            ) {
              link.parentElement.classList.add("active");
            } else {
              link.parentElement.classList.remove("active");
            }
          });
        });
      }
    },

    __getArticleContent() {
      // Set the AC article content using the Vue obj
      if (
        $("[data-article-content]").length > 0 &&
        !$("[data-article-content]").hasClass("article-body")
      ) {
        const articleObj = app.selectors.articleData;
        $("[data-article-content]").each((index, item) => {
          var article = JSON.parse($(item).text());
          
          var link = article.view_detail;
          // var $compareArticle = $(article.article.faq_2)
          //   .find("[data-compare]")
          //   .removeClass("col-md-6")
          //   .addClass("w-100 px-3");
          //   console.log($compareArticle);
          let data = '';
          if (article.article.faq_2 != null){
            data = '<div class="w-100 carousel-cell">'+ article.article.faq_2 + '<a class="d-none" data-link='+ link +'></a></div>';  
          } else {
            let $compareArticle = $(article.article.faq).find("[data-compare]");
            data = '<div class="w-100 px-3 carousel-cell">'+ $compareArticle[0].innerHTML + '<a class="d-none" data-link='+ link +'></a></div>';  
          }
          
          $(".all-comcompetitors").append(data);
        });
        // $(".accordion").each((index, item) => {
        //   $(item)
        //     .find(".card")
        //     .each((ind, it) => {
        //       $(it).find('.collapse').addClass('show');
        //       $(it)
        //         .find("button")
        //         .removeAttr("data-toggle");
        //     });
        // });
        var flickity_art = new Flickity(".all-comcompetitors", {
          contain: true,
          prevNextButtons: true,
          pageDots: false,
          adaptiveHeight: true,
          wrapAround: false,
        });
        $(".all-comcompetitors .carousel-cell.is-selected").on('show.bs.collapse', function () {
          flickity_art.resize();
        });
        app.__getArticleDivHeight(flickity_art);
        app.__getViewPageLink(flickity_art);
       
        setTimeout(() => {
          $(".all-comcompetitors .carousel-cell").each((index, item) => {
              if ($(item).hasClass("is-selected")) {
                const $link = $(item).attr("data-link");
                $("[data-view-link]").attr("href", $link);
              }
            }
          );
        }, 300);
      }
    },

    __getViewPageLink(flickity_art) {
      $(".flickity-button").click(() => {
        setTimeout(() => {
          $(".all-comcompetitors .flickity-viewport .carousel-cell").each(
            (index, item) => {
              if ($(item).hasClass("is-selected")) {
                const link = $(item).attr("data-link");
                $("[data-view-link]").attr("href", link);
              }
            }
          );
          app.__getArticleDivHeight(flickity_art);
        }, 200);
      });
      if ($(".app-compare-div").length > 0) {
        const size_li = $(".app-compare-div").length;
        let start_div = parseInt(
          $(".app-compare-div")
            .parents(".row")
            .attr("data-items-page")
        );
        const no_of_divs = start_div / 2;
        let count = 1;
        // $('.app-compare-div:lt('+start_div+')').show();
        $("#loadmore").click(function () {
          const page_url = window.location.origin + window.location.pathname;
          start_div =
            start_div + no_of_divs <= size_li
              ? start_div + no_of_divs
              : size_li;
          $(`.app-compare-div:lt(${start_div})`).show();
          window.history.pushState({}, "", `${page_url}?page=${count}`);
          const scroll_div_no = start_div - no_of_divs;
          $("html, body").animate(
            {
              scrollTop:
                $(`.app-compare-div:eq(${scroll_div_no})`).offset().top - 120,
            },
            1000
          );
          if (start_div >= size_li) {
            $(this).hide();
          }
          count++;
        });
      }
    },

    __getArticleDivHeight(flickity_art) {
      $(".app-page #faq > div").each(function (index, item) {
        var $faq_ele = $(this);
        $faq_ele.removeAttr("style");
        var faq_div_height = $(this).outerHeight();
        $(
          ".all-comcompetitors .flickity-slider [data-compare].is-selected > div"
        ).each(function (ind, it) {
          if (index === ind) {
            $(this).removeAttr("style");
            let set_height;
            if (faq_div_height > $(this).outerHeight()) {
              set_height = faq_div_height;
            } else {
              set_height = $(this).outerHeight();
            }
            $(this).outerHeight(set_height);
            $faq_ele.outerHeight(set_height);
          }
        });
      });
      if (flickity_art && flickity_art != undefined) {
        flickity_art.resize();
      }
    },

    __locationPage() {
      if ($("#original_map").length > 0) {
        const $map_description = $(".custome_popover");
        $("#original_map .enabled").hover(
          function () {
            $map_description.find("> div").addClass("d-none");
            $map_description.addClass("d-block");
            const target_ele = $(this).attr("id");
            $map_description.find(`.${target_ele}`).removeClass("d-none");
          },
          () => {
            $map_description.removeClass("d-block");
            $map_description.find("> div").addClass("d-none");
          }
        );

        $(document).on("mousemove", (e) => {
          $map_description.css({
            left: e.pageX,
            top: e.pageY - 40,
          });
        });
      }
    },

    __appProduct() {
      // ---------add content for app product template
      $(".tagline").prepend($(".tagline:eq(0) > span").show());
      $(".keyhighlights-section").append($(".keyhighlights:eq(0)").show());
      $(".plan-trial-text").append($(".plan-text").text());
      $("#price-plan").append($(".price-plan").show());
      app.__setDivSameHeight(".new-product .plan-div .card-body");
      $(".hero-background-slider-wrapper .flickity-viewport").addClass(
        "h-auto"
      );
    },

    __appCollection() {
      // Tab selection with a dropdown list for small devices of the app collection page
      $("#tab_category").on("change", function (e) {
        $("#nav-tab a")
          .eq($(this).val())
          .tab("show");
      });
    },

    __addons() {
      // ATC add-ons of the starter pack and BFCM package page
      $("#addons-btn-2").on("click", (event) => {
        event.preventDefault();
        $("#addons-btn").trigger("click");
      });
      $("#addons-btn").on("click", (event) => {
        const arr = [];
        event.preventDefault();
        const main_product_id = $(".main-product .add-to-cart").attr(
          "data-product-id"
        );
        let main_flag = true;
        let uid;

        if (app.cart_item_id.length > 0) {
          app.cart_item_id.forEach((item) => {
            if (main_product_id === item.variant_id) {
              main_flag = false;
              uid = item.properties.uid;
            }
          });
        } else {
          main_flag = true;
        }

        $(".add-ons-product .addons-item").each(function (e) {
          const $input = $(this).find("td input");
          // eslint-disable-next-line eqeqeq
          if ($input.prop("checked") == true) {
            const variant_id = $input.val();
            // eslint-disable-next-line quote-props
            arr.push({
              variant_id: variant_id,
              properties: {
                _addon_product: "true",
                is_package_product: "true",
                uid: uid,
              },
            });
          }
        });

        if (main_flag) {
          // eslint-disable-next-line quote-props
          arr.push({
            variant_id: main_product_id,
            properties: { is_package_product: "true" },
          });
        }

        if (arr.length > 0) {
          app._addToCart("", "", arr);
        } else {
          app._toggleCartDrawer();
        }
      });

      $(".addons-btn-recharge").on("click", function (event) {
        const arr = [];
        event.preventDefault();
        const main_product_id = $(this).attr("data-variant-id");
        let main_flag = true;
        let uid;

        if (app.cart_item_id.length > 0) {
          app.cart_item_id.forEach((item) => {
            if (main_product_id === item.variant_id) {
              main_flag = false;
              uid = item.properties.uid;
            }
          });
        } else {
          main_flag = true;
        }

        let remove_main_pro;
        let item_uid;
        const remove_data = [];
        $(".add-ons-product .addons-item").each(function (e) {
          const $input = $(this).find("td input");

          // eslint-disable-next-line eqeqeq
          if ($input.prop("checked") == true) {
            if (app.cart_item_id.length > 0) {
              app.cart_item_id.forEach((item) => {
                if ($input.val() === item.variant_id) {
                  item_uid = item.properties.uid;
                }
              });
            }
            const variant_id = $input.val();
            // eslint-disable-next-line quote-props
            arr.push({
              variant_id: variant_id,
              properties: {
                _addon_product: "true",
                is_package_product: "true",
                uid: uid,
              },
            });
          }
        });

        if (main_flag) {
          // eslint-disable-next-line quote-props
          arr.push({
            variant_id: main_product_id,
            properties: { is_package_product: "true" },
          });
        }

        let remove_flag = false;
        const qtyArray = [];
        app.cart_item_id.forEach((item, index) => {
          remove_main_pro = "";
          if (item_uid === item.properties.uid) {
            remove_main_pro = item.variant_id;
            remove_flag = true;
            qtyArray.push(0);
          } else {
            qtyArray.push(item.quantity);
          }
        });
        const params = {
          type: "POST",
          url: "/cart/update.js",
          data: {
            updates: qtyArray,
          },
          dataType: "json",
          async: false,
          success(responce) {
            setTimeout(() => {
              if (arr.length > 0) {
                app._addToCart("", event, arr);
              }
            }, 200);
          },
          error(er) {
            const err = $.parseJSON(er.responseText);
            return false;
          },
        };
        $.ajax(params);
      });
    },

    __downloadFolders() {
      $(document).on("click", ".download-demo", (e) => {
        e.preventDefault();
        const urls = [
          "https://cdn.shopify.com/s/files/1/1564/7647/files/Vintage_set.zip",
          "https://cdn.shopify.com/s/files/1/1564/7647/files/ICONS.zip",
        ];
        const zip = new JSZip();
        let count = 0;
        const zipFilename = $(".heading-article .heading-title").text();
        urls.forEach((url) => {
          const filename = url.substr(url.lastIndexOf("/") + 1);
          // loading a file and add it in a zip file
          JSZipUtils.getBinaryContent(url, (err, data) => {
            if (err) {
              throw err; // or handle the error
            }
            zip.file(filename, data, { binary: true });
            count++;

            if (count === urls.length) {
              // eslint-disable-next-line promise/catch-or-return
              zip.generateAsync({ type: "blob" }).then((content) => {
                saveAs(content, `${zipFilename}.zip`);
              });
            }
          });
        });
      });
    },

    __patternFilter() {
      // Open the patterns filter popup
      $(".refine").on("click", (e) => {
        e.preventDefault();
        $(".category-filters").addClass("active");
        app.isOverlayVisible = true;
        app._lockScroll();
      });

      // Close the patterns filter popup
      $(".filter-close").on("click", (e) => {
        e.preventDefault();
        if ($(e.target).closest(".filter-close").length > 0) {
          $(".category-filters").removeClass("active");
          app.isOverlayVisible = false;
          app._unlockScroll();
        }
      });

      // Close the patterns filter popup when clicks on any point except
      $(document).on("click", (e) => {
        if (
          $("body .category-filters").length > 0 &&
          $("body .category-filters").hasClass("active")
        ) {
          if (
            $(e.target).closest(".category-filters").length === 0 &&
            $(e.target).closest(".refine").length === 0 &&
            $(e.target).closest(".navigation-main").length === 0 &&
            $(e.target).closest(".navbar").length === 0
          ) {
            $(".filter-close").trigger("click");
          }
        }
      });

      // Make the sidebar filter sticky of the patterns
      if ($(".sticky-patterns-sidebar").length > 0) {
        const sticky_top_start = $(".sticky-patterns-sidebar").offset().top;
        $(window).scroll(() => {
          const sticky_top = $(".sticky-patterns-sidebar").offset().top;
          if (sticky_top > sticky_top_start) {
            // if($('.sticky-patterns-sidebar').hasClass('sticky-patterns') == false) {
            $(".sticky-patterns-sidebar").addClass("sticky-patterns");
            // }
          } else {
            // if($('.sticky-patterns-sidebar').hasClass('sticky-patterns') == true) {
            $(".sticky-patterns-sidebar").removeClass("sticky-patterns");
            // }
          }
        });
      }

      setTimeout(() => {
        $('.filter-accordion input[type="checkbox"]').on("change", (e) => {
          e.preventDefault();
          if (
            $('.filter-accordion input[type="checkbox"]:checked').length > 0
          ) {
            $(".category-types .category").each(function () {
              $(this).hide();
              $(this)
                .find(".product-div")
                .each(function () {
                  $(this).hide();
                });
            });
            $(".filter-accordion .card .card-header h4").each(function () {
              $(this).removeClass("active");
            });
            const pro_handle = [];
            $('.filter-accordion input[type="checkbox"]:checked').each(
              function () {
                var ele = `.${$(this).attr("data-value")}`;
                $(".category-types")
                  .find(".no-products")
                  .remove();
                if ($(this).parents(".collapse").length <= 0) {
                  if ($(this).prop("checked") === true) {
                    $(".category-types")
                      .find(ele)
                      .show();
                    $(".category-types")
                      .find(ele)
                      .find(".all")
                      .show();
                    $(this)
                      .siblings("h4")
                      .addClass("active");
                  } else {
                    $(".category-types")
                      .find(ele)
                      .hide();
                    $(".category-types")
                      .find(ele)
                      .find(".all")
                      .hide();
                    $(this)
                      .siblings("h4")
                      .removeClass("active");
                  }
                } else {
                  $(".category-types .category")
                    .find(ele)
                    .find("[data-product-handle]")
                    .each(function (data_index, data_item) {
                      if (
                        pro_handle.indexOf(
                          $(this).attr("data-product-handle")
                        ) === -1
                      ) {
                        pro_handle.push($(this).attr("data-product-handle"));
                        $(this).show();
                      } else {
                        $(this).hide();
                      }
                    });
                  $(this)
                    .parents(".collapse")
                    .siblings(".card-header")
                    .find("h4")
                    .addClass("active");
                  if ($(this).prop("checked") === true) {
                    $(".category-types .category")
                      .find(ele)
                      .parents(".category")
                      .show();
                    $(".category-types .category")
                      .find(ele)
                      .siblings(".all")
                      .hide();
                    $(".category-types .category")
                      .find(ele)
                      .show();
                  } else {
                    $(".category-types .category")
                      .find(ele)
                      .parents(".category")
                      .hide();
                    $(".category-types .category")
                      .find(ele)
                      .siblings(".all")
                      .show();
                    $(".category-types .category")
                      .find(ele)
                      .hide();
                  }
                  if (pro_handle.length <= 0) {
                    $(".category-types").append(
                      '<h3 class="no-products text-center w-100">No item available for this subcategory</h3>'
                    );
                  }
                }
              }
            );
          } else {
            $(".filter-accordion .card .card-header h4").each(function () {
              $(this).removeClass("active");
            });
            $(".category-types .category").each(function () {
              $(this).show();
              $(this)
                .find(".all")
                .show();
            });
          }
          const $target_ele = $(".category-types");
          app._animateToSection($target_ele, 150, e);
          $(".filter-close").trigger("click");
        });

        // Sorting according to the priority on the patterns page
        $('.sorting-items input[type="radio"]').on("change", function (e) {
          const $event_target = $(event.currentTarget);
          $(this)
            .parents(".category")
            .find(".product-div")
            .each(function () {
              $(this).hide();
            });
          $(this)
            .parents(".sorting-items")
            .find("li")
            .each(function () {
              $(this).removeClass("active");
            });
          if ($('.sorting-items input[type="radio"]:checked').length > 0) {
            var ele = `.${$(this).attr("data-value")}`;
            $(this)
              .parents(".category")
              .find(".no-products")
              .remove();
            if ($(this).prop("checked") === true) {
              $(this)
                .parents(".category")
                .find(ele)
                .show();
              $(this)
                .parents("li")
                .addClass("active");
            } else {
              $(this)
                .parents(".category")
                .find(ele)
                .hide();
              $(this)
                .parents("li")
                .removeClass("active");
            }
            if (
              $(this)
                .parents(".category")
                .find(".product-div:visible").length <= 0
            ) {
              $(this)
                .parents(".category")
                .find(".category_list")
                .append(
                  '<h3 class="no-products text-center w-100">No item available for this priority</h3>'
                );
            } else {
              if (
                $(this)
                  .parents(".category")
                  .find(".product-div")
                  .find("div:visible").length <= 0
              ) {
                $(this)
                  .parents(".category")
                  .find(".category_list")
                  .append(
                    '<h3 class="no-products text-center w-100">No item available for this priority</h3>'
                  );
              }
            }
          } else {
            $(this)
              .parents(".category")
              .find(".product-div.all")
              .each(function () {
                $(this).show();
                $(this)
                  .parents(".category")
                  .find(".no-products")
                  .remove();
                $(".sorting-items li").removeClass("active");
                $(this)
                  .siblings(".product-div:not(.all)")
                  .hide();
              });
          }
        });
      }, 2000);
    },

    __patternsProduct() {
      // Append the description product of the patterns product
      $(".patterns_product .prod-desc-1").append(
        $(".desc-1").removeClass("d-none")
      );
      $(".patterns_product .prod-desc-2").append(
        $(".desc-2").removeClass("d-none")
      );
    },

    __allPatterns() {
      $("[data-all-patterns-json]").each((ind, item) => {
        const patternsObj = $(item).html();
        const patternsData = JSON.parse(patternsObj);
        let priority_img = "";
        patternsData.products.forEach((item_prod) => {
          item_prod.tags.forEach((tag) => {
            if (tag.indexOf("priority") >= 0) {
              priority_img = tag.replace("priority-", "");
            }
            item_prod.priority_img = priority_img;
          });
        });
        app.all_patterns.collection.push(patternsData);
      });

      $("[data-collections-coll-json]").each((ind, item) => {
        const collObj = $(item).html();
        const collData = JSON.parse(collObj);
        let priority_img = "";
        const coll_handle = collData.collection.handle.replace(
          "-ab-testing",
          ""
        );
        const product_tags = [];
        collData.products.forEach((item_prod) => {
          item_prod.tags.forEach((tag) => {
            if (tag.indexOf("priority") >= 0) {
              priority_img = tag.replace("priority-", "");
            }
            item_prod.priority_img = priority_img;
            let available_tag = true;
            for (let i = 0; i < product_tags.length; i++) {
              if (product_tags[i].handle === tag) {
                available_tag = false;
                return false;
              }
            }
            if (
              available_tag &&
              tag.indexOf("priority") < 0 &&
              tag.indexOf(coll_handle) > -1
            ) {
              const coll_pro_tag = {};
              coll_pro_tag.handle = tag;
              const tag_title = tag.replace(/[-\s]/g, " ").trim();
              coll_pro_tag.title = tag_title;
              product_tags.push(coll_pro_tag);
            }
          });
        });
        if (product_tags.length) {
          collData.collection.tags = product_tags;
        } else {
          collData.collection.tags = "0";
        }
        app.collections_col.collection.push(collData);
      });
    },

    __patternsCaseStudy() {
      if ($(window).width() < 992 || $(window).width() > 1200) {
        $(".blog-case-studies .article-div:eq(0) img").outerHeight(
          $(".blog-case-studies .article-div:eq(1) img").outerHeight()
        );
      } else if ($(window).width() >= 992 || $(window).width() <= 1200) {
        $(".blog-case-studies .article-div:eq(0) .row img").outerHeight(
          $(".blog-case-studies .article-div:eq(0) .row").outerHeight()
        );
      }

      $(window).resize(() => {
        app.__patternsCaseStudy();
      });
    },

    __rechargrRecipesProduct() {
      $(".switch input[type=checkbox]").on("change", function (e) {
        if ($(this).prop("checked") == true) {
          $(this)
            .parents(".toggle-switch")
            .siblings(".monthly-products")
            .addClass("d-none");
          $(this)
            .parents(".toggle-switch")
            .siblings(".annually-products")
            .removeClass("d-none");
        } else {
          $(this)
            .parents(".toggle-switch")
            .siblings(".annually-products")
            .addClass("d-none");
          $(this)
            .parents(".toggle-switch")
            .siblings(".monthly-products")
            .removeClass("d-none");
        }
      });
    },

    __hulkthemeProduct() {
      // To set the href attr of "Demo" button on the HT product
      const current_path = window.location.href;
      const current_tag = current_path.split("?q=");
      let preview;
      let category;
      const themeSplit = current_tag[0].split("products/");
      let themeName;
      if (themeSplit.length > 1) {
        themeName = themeSplit[1].split("-");
      }
      if (current_tag[1] == undefined) {
        preview = $(".product-description")
          .find(".live-preview-hide")
          .attr("data-default");
        category = "default";
      } else {
        preview = $(".product-description")
          .find(".live-preview-hide")
          .data(current_tag[1]);
        category = current_tag[1];
      }
      if (themeName) {
        if (preview == undefined) {
          var get_live_preview = $(".product-description")
            .find(".live-preview-hide")
            .attr("href");
          $(".live-preview").attr(
            "href",
            `/pages/preview-theme/?tname=${themeName[0]}&tcategory=${current_tag[1]}&buy=${current_path}&fsrc=${get_live_preview}`
          );
        } else {
          $(".live-preview").attr(
            "href",
            `/pages/preview-theme/?tname=${themeName[0]}&tcategory=${category}&buy=${current_path}&fsrc=${preview}`
          );
        }
      }
      // To append the content from the product desc on the HT product page
      const get_theme_documentation = $(".product-description")
        .find(".theme-documentation-hide")
        .attr("href");
      $(".theme-documentation").attr("href", get_theme_documentation);

      const get_about_theme = $(".product-description")
        .find(".about-theme-hide")
        .html();
      $(".about_theme").html(get_about_theme);

      // const get_extra_desc = $('.product-description').find('.extra-desc-hide').html();
      // $('.product-extra-desc').html(get_extra_desc);
    },

    __migrationCenterProduct() {
      if ($(".migration-center-product").length > 0) {
        const $mig_ele = $("section").eq(-3);
        if (
          $mig_ele.find("h2").text() ===
          "HulkApps - Making Shopify Migration A Breeze"
        ) {
          $mig_ele
            .find(".row")
            .find("img")
            .parent()
            .removeClass("d-flex")
            .addClass("d-none");
        }
      }
    },

    __serviceProduct() {
      // For service product design changes using jQuery
      if ($(".service-product").length > 0) {
        const $disclaimer_html = $(
          ".prod-desc .border.border-dark-pink"
        ).detach();
        $disclaimer_html.removeClass("my-5");

        app._serviceProductLi(".service-product .prod-desc ul");

        // Includes/Not-includes design changes via jQuery
        if ($(".service-product .includes").length > 0) {
          // eslint-disable-next-line eqeqeq
          if ($(".not-includes").text() == "") {
            $(".not-includes")
              .parent("div")
              .css("display", "none");
          }
          $(".includes, .not-includes").removeAttr("style");
          $(".includes h5, .not-includes h5")
            .siblings("img")
            .remove();
          $(".includes h5, .not-includes h5").removeClass();
          $(".includes h5").addClass("mb-0 text-hulkgrassy");
          $(".not-includes h5").addClass("mb-0 text-gray-medium");
          $(".includes ul, .not-includes ul")
            .removeClass()
            .addClass("list-unstyled");
          $(".includes ul li").each(function (index, item) {
            const li_text = $(this).html();
            $(this).addClass("d-flex align-items-baseline");
            $(this).html(
              `<div class="d-inline-flex align-items-center li-div">${li_text}</div>`
            );
            $(this)
              .find(".li-div")
              .before(
                '<img src="https://cdn.shopify.com/s/files/1/1564/7647/files/green_check.svg?v=1616501896" alt="tick mark icon" class="mr-2 align-middle">'
              );
            // $(this).find('.product-tooltip').html('<img src="https://cdn.shopify.com/s/files/1/1564/7647/files/info_d4767a77-6e16-4dda-95aa-87abb1923c3d.svg?v=1616502531" alt="Shopify - product-tooltip">');
            // $(this).find('.product-tooltip').removeClass('product-tooltip');
          });
          $(".not-includes ul li").each(function (index, item) {
            const li_text = $(this).html();
            $(this).addClass("d-flex align-items-baseline");
            $(this).html(
              `<div class="d-inline-flex align-items-center li-div">${li_text}</div>`
            );
            $(this)
              .find(".li-div")
              .before(
                '<img src="https://cdn.shopify.com/s/files/1/1564/7647/files/Dark_gray_check.svg?v=1616501890" alt="tick mark icon" class="mr-2 align-middle">'
              );
            // $(this).find('.product-tooltip').html('<img src="https://cdn.shopify.com/s/files/1/1564/7647/files/info_d4767a77-6e16-4dda-95aa-87abb1923c3d.svg?v=1616502531" alt="Shopify - product-tooltip">');
            // $(this).find('.product-tooltip').removeClass('product-tooltip');
          });
          $(".includes")
            .parents(".row:eq(0)")
            .after('<hr class="mb-0 mt-4">');
        }
        $(".service-product .product-tooltip").each(function (index, item) {
          $(this).html(
            '<img src="https://cdn.shopify.com/s/files/1/1564/7647/files/info_d4767a77-6e16-4dda-95aa-87abb1923c3d.svg?v=1616502531" alt="Shopify - product-tooltip">'
          );
          $(this).removeClass("product-tooltip");
        });
        // Changing from bullets to the tick marks
        $(".service-product .prod-desc p").each(function (index, item) {
          if (
            $(this)
              .text()
              .startsWith("Reasons to")
          ) {
            $(this)
              .next("ul")
              .addClass("list-unstyled");
            $(this)
              .next("ul")
              .find("li")
              .each(function (index, item) {
                const ul_li_text = $(this).html();
                $(this).html(
                  '<i class="ion ion-md-checkmark mr-2 text-hulkdarkpurple text-18"></i>'
                );
                $(this)
                  .find("i")
                  .after(ul_li_text);
              });
          }
        });

        // Moving description from one place to anoother
        const $includes_row = $(".includes").parents(".row:eq(0)");
        const $next_of_includes = $includes_row.nextAll();
        // console.log($includes_row, 'next', $next_of_includes);
        $(".white-section").append($includes_row);
        $(".white-section").append($next_of_includes);
        if ($(".prod-desc").children().length > 1) {
          // console.log('called if');
          if ($(".prod-desc > div:last").length > 0) {
            $(".white-section").append($(".prod-desc > div:last"));
            // $('.includes').parents('.row:eq(0)').after($('.prod-desc > div:last'));
          }
          if ($(".prod-desc").children().length > 1) {
            $(".white-section").prepend($(".prod-desc > div:last"));
            $(".includes")
              .parents(".row:eq(0)")
              .after($(".prod-desc > div:last"));
          }
          if ($(".prod-desc > div > div").children().length > 1) {
            $(".white-section").prepend(
              $(".prod-desc > div > div")
                .children()
                .eq(2)
                .nextAll()
            );
          }
        } else if ($(".prod-desc > div").children().length > 1) {
          // console.log('called else if');
          // if ($('.prod-desc > div > div:last').length > 0) {
          // console.log('1st-->', $('.prod-desc > div > div:last'));
          // $('.white-section').append($('.prod-desc > div > div:last'));
          // $('.includes').parents('.row:eq(0)').after($('.prod-desc > div > div:last'));
          // }
          // if ($('.prod-desc > div').children().length > 1) {
          // console.log('2nd-->', $('.prod-desc > div > div:last'));
          // $('.white-section').prepend($('.prod-desc > div > div:last'));
          // console.log('3rd-->', $('.prod-desc > div > div:last'));
          // $('.includes').parents('.row:eq(0)').after($('.prod-desc > div > div:last'));
          // }
          // Set this condition for 3 divs in prod-desc(main content 1st div, final thoughts div and middle content div) e.g. https://www.hulkapps.com/products/advanced-reporting-site-speed-optimization
          if ($(".prod-desc > div").children().length === 3) {
            $(".white-section").append($(".prod-desc > div > div:eq(1)"));
            $(".white-section").append($(".prod-desc > div > div:last"));
          }
        }

        $(".white-section")
          .parents(".row")
          .after($disclaimer_html);

        $(".prod-desc").removeClass("d-none");
        $(".white-section").removeClass("d-none");

        $(".switch input[type=checkbox]").on("change", function (e) {
          let checked_val = "";
          if ($(this).prop("checked") === true) {
            checked_val = $(".turnaround-time .switch")
              .next()
              .attr("data-val");
          } else {
            checked_val = $(".turnaround-time .switch")
              .prev()
              .attr("data-val");
          }
          $(".size_swatch .size-swatch input").each(function (index, item) {
            if ($(this).val() === checked_val) {
              $(this).trigger("click");
              return false;
            }
          });
        });
      }

      setTimeout(() => {
        if ($("body .service-product").length > 0) {
          $(".white-section p.font-weight-bold").each(function (index, item) {
            if ($(this).text() === "Final thoughts:") {
              $(this)
                .next()
                .html(
                  'Experts at HulkApps can develop solutions that allow you to expand or add new functionality to your Shopify store without sweating it out. Our feasible solutions can help drive your store towards success. <a href="pages/contact">Connect with us</a> for better store management.'
                );
              return false;
            }
          });
        }
      }, 500);

      // Added alt text to the icon of disclaimer icon
      $(".service-product .border-dark-pink img").attr("alt", "Disclaimer");

      setTimeout(() => {
        // Scroll down to the add-ons section for the service product
        $(".add-on-view").on("click", () => {
          $("html, body").animate(
            {
              scrollTop: $("#product-addons").offset().top - 150,
            },
            1000
          );
        });
      }, 1000);
    },

    __serviceCollection() {
      // To show the active cat/sub-cat on the shopify services page
      const current_url = window.location.pathname;
      $(
        ".service-collection .feature-collection .cate-subcate-list a.subcate-link"
      ).each(function (index, item) {
        if (current_url === $(this).attr("href")) {
          $(this).addClass("text-hulkdarkpurple");
          $(this)
            .parents(".collapse")
            .addClass("show");
          $(this)
            .parents(".collapse")
            .prev("a")
            .attr("aria-expanded", "true")
            .removeClass("collapsed");
          $(this)
            .parents(".collapse")
            .parents(".collapse")
            .addClass("show");
          $(this)
            .parents(".collapse")
            .parents(".collapse")
            .prev("a")
            .attr("aria-expanded", "true")
            .removeClass("collapsed");
          return false;
        }
      });
    },

    __serviceCustomQuoteForm() {
      $("#service_btn").on("click", (e) => {
        e.preventDefault();
        const $form = $(".migration_service_form");
        const form_id = $form.attr("id");
        const token_id = $form.attr("data-token");
        $("#success-msg").addClass("d-none");
        $.fn.serializeObject = function () {
          var o = {};
          var data_o = {};
          var a = this.serializeArray();
          $.each(a, function () {
            if (o[this.name] !== undefined) {
              if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
              }
              o[this.name].push(encodeURI(this.value) || "");
            } else {
              o[this.name] = encodeURI(this.value) || "";
            }
          });
          return o;
        };

        var $data1 = $form.serializeObject();
        var form_data = { formResponse: $data1 };
        let err_flag = true;
        $(".error-msg").remove();
        // var phoneno = /^\d{10}$/;  /^[+-]?\d{13}+$/
        // var phone_pattern = /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/; phone_pattern.test( input_value );
        // if (!$(this).val().match('^[a-zA-Z]+$') ) {
        // ^[a-zA-Z0-9& ]*$ // allow A - Z characters, 0 -9 digits, "&" and a space
        $(".migration_service_form .form-control").each(function (index, item) {
          const current_val = $(this).val();
          let regex;
          if ($(this).hasClass("required-field") && current_val === "") {
            $(this).after(
              `<p class="m-0 text-danger error-msg">${$(this).attr(
                "name"
              )} is required</p>`
            );
            err_flag = false;
          } else if ($(this).hasClass("full-name")) {
            regex = /^[a-zA-Z0-9 ,.'-]+$/;
            if (!regex.test(current_val)) {
              $(this).after(
                `<p class="m-0 text-danger error-msg">Provide valid ${$(this)
                  .attr("name")
                  .toLowerCase()}</p>`
              );
              err_flag = false;
            }
          } else if ($(this).hasClass("phone-no") && current_val !== "") {
            regex = /^[0-9-+]+$/;
            if (!regex.test(current_val)) {
              $(this).after(
                '<p class="m-0 text-danger error-msg">Provide valid phone number</p>'
              );
              err_flag = false;
            }
          } else if ($(this).hasClass("company-name")) {
            regex = /^[a-zA-Z0-9& ]*$/;
            if (!regex.test(current_val)) {
              $(this).after(
                '<p class="m-0 text-danger error-msg">Provide valid company name</p>'
              );
              err_flag = false;
            }
          } else if ($(this).hasClass("store-url")) {
            regex = /^[a-zA-Z0-9&\-\/.:]*$/;
            if (
              !regex.test(current_val) ||
              current_val.indexOf(".myshopify.com") === -1
            ) {
              $(this).after(
                '<p class="m-0 text-danger error-msg">Provide valid store url</p>'
              );
              err_flag = false;
            }
          } else {
            regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            const email_ele = $(this).attr("type");
            if (email_ele === "email") {
              if (!regex.test(current_val)) {
                $(this).after(
                  '<p class="m-0 text-danger error-msg">Provide valid email format</p>'
                );
                err_flag = false;
              }
            }
          }
        });
        if (err_flag) {
          if ($("#terms_service").prop("checked") === false) {
            $("html, body").animate(
              {
                scrollTop: $("#terms_service").offset().top - 160,
              },
              1000
            );
          } else {
            // console.log(JSON.stringify(form_data), form_data);
            // return false;
            $.ajax({
              url: `https://formbuilder.hulkapps.com/forms/${form_id}`,
              type: "POST",
              async: true,
              crossDomain: true,
              headers: {
                "X-Form-Access-Token": token_id,
                Accept: "application/json",
                "Content-Type": ["application/json", "text/plain"],
                "cache-control": "no-cache",
                "Access-Control-Allow-Origin": "*",
              },
              contentType: false,
              processData: false,
              mimeType: "multipart/form-data",
              data: JSON.stringify(form_data),
              dataType: "json",
              success(getdata) {
                if (getdata.validate == undefined || getdata.validate) {
                  $("#success-msg").removeClass("d-none");
                }
              },
            });
          }
        } else {
          $("html, body").animate(
            {
              scrollTop: $form.offset().top - 160,
            },
            1000
          );
        }
      });
    },

    __custom_hulkcode() {
      $(".newsletterFooterCustomerSubmit").on("click", function (e) {
        var emailId = $.trim(
          $(this)
            .closest("email")
            .find("#newsletterFooterCustomerEmail")
            .val()
        );
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (emailId.length <= 0) {
          $(".form-submiterror").show();
        } else {
          if (regex.test(emailId) === false) {
            $(".form-submiterror").show();
            return false;
          } else {
            $(".form-submiterror").hide();
            return true;
          }
        }
      });
      var url = location.href;
      if (url.indexOf("challenge#NewsletterFooter") > -1) {
        $(".newsletter-section").hide();
      }

      $(".contact-form input").focus(function (e) {
        $(this)
          .parent()
          .addClass("focus");
      });
      $("form input").blur(function (e) {
        var value = $(this).val();
        // eslint-disable-next-line eqeqeq
        if (value != "") {
          $(this)
            .parent()
            .addClass("focus");
        } else {
          $(this)
            .parent()
            .removeClass("focus");
        }
      });
    },

    __productAddons() {
      $("[data-service-addons-json]").each((ind, item) => {
        const addonObj = $(item).html();
        const addonsData = JSON.parse(addonObj);
        const addonsArr = addonsData.addon_product_handles.split(",");
        if (addonsArr.length > 0) {
          addonsArr.forEach((item_prod, index) => {
            // $.ajaxSettings.async = false;
            jQuery.getJSON(
              `/products/${item_prod.trim()}.js`,
              (product_details) => {
                axios
                  .get(`/products/${item_prod.trim()}?view=json`)
                  .then((product_response) => {
                    const addons_meta = product_response.data.metafields;
                    const addons_meta_tooltip =
                      product_response.data.metafields_product_tooltip;
                    product_details.meta = addons_meta;
                    product_details.addons_tooltip = addons_meta_tooltip;
                  });
                app.productAddons.products.push(product_details);
              }
            );
            // $.ajaxSettings.async = true;
          });
        }
      });

      const addons_var = setInterval(addons_ele, 1000);

      function addons_ele() {
        if ($("#product-addons").find("[data-nice-select]").length > 0) {
          $("#product-addons")
            .find("[data-nice-select]")
            .niceSelect();

          $(".selector-wrapper select").each(function () {
            $(this).on("change", ($event) => {
              app._getVariant($event, "addon product");
            });
          });

          // $('.product-addons-div .custom-checkbox .custom-control-input').on('click', function(event) {
          //   const data_index = $(this).attr('data-index');
          //   const data_variant_id = $(this).attr('data-variant-id');
          //   const final_data_variant_id = parseInt(data_variant_id);
          //   const product_id = $(this).parents('.product-addons-div').attr('data-product-addon-id');
          //   const final_product_id = parseInt(product_id);
          //   if (!app.pro_Available_flag) {
          //     if ($(this).prop('checked') == true) {
          //       app._addCustomProductAddon(final_data_variant_id, event);
          //     } else {
          //       app._removeCustomProductAddon(final_product_id, final_data_variant_id, data_index, event);
          //     }
          //   } else {
          //     $(this).prop('checked', false);
          //   }
          // });
          clearInterval(addons_var);
        } else {
          setTimeout(() => {
            clearInterval(addons_var);
          }, 5000);
        }
      }
    },

    __addonsChecked(event) {
      // $('.product-addons-div .custom-checkbox .custom-control-input').on('click', function(event) {
      const $this = $(event.currentTarget);
      const data_index = $this.attr("data-index");
      const data_variant_id = $this.attr("data-variant-id");
      const final_data_variant_id = parseInt(data_variant_id);
      const product_id = $this
        .parents(".product-addons-div")
        .attr("data-product-addon-id");
      const final_product_id = parseInt(product_id);
      if (!app.pro_Available_flag) {
        if ($this.prop("checked") == true) {
          app._addCustomProductAddon(final_data_variant_id, event);
        } else {
          app._removeCustomProductAddon(
            final_product_id,
            final_data_variant_id,
            data_index,
            event
          );
        }
      } else {
        $this.prop("checked", false);
      }
      // });
    },

    _addCustomProductAddon(variantId, event) {
      const product = app.productAddons.products.find(
        (x) => x.variants[0].id === variantId
      );
      let obj = {
        product_id: product.id,
        variant_id: product.variants[0].id,
        variant_price: product.variants[0].price,
        product_title: product.title,
        variant_title: product.variants[0].option1,
        variant_name: product.options,
      };

      app.productAddons.selectedVariant.push(product.variants[0]);
      app.productAddons.selectedProduct.push(obj);
      app.productAddons.currentVariant = product.variants[0];
      $(`[data-product-addon-id="${product.id}"] [data-single-option-selector]`)
        .val(
          $(
            `[data-product-addon-id="${product.id}"] [data-single-option-selector] option:first`
          ).val()
        )
        .trigger("change");
      $(`[data-product-addon-id="${product.id}"] [data-product-price]`).html(
        app._formatMoney(app.productAddons.currentVariant.price)
      );
      app.productAddons.totalValue +=
        parseFloat(
          app._formatMoney(product.variants[0].price).replace("$", "")
        ) * 100;
      // console.log('called product', product.selected);
      product.selected = true;
      // console.log('called product after', product.selected);
    },

    _removeCustomProductAddon(productId, variantId, index, event) {
      index = parseInt(index);
      const removeProduct = app.productAddons.selectedProduct.find(
        (x) => x.product_id === productId
      );
      const product = app.productAddons.products.find(
        (x) => x.id === productId
      );

      $("#product-addons [data-product-addon-id]").each((i, item) => {
        if (i == index) {
          const $this = $("#product-addons [data-product-addon-id]")[i];
          const $select_el = $($this).find(".selector-wrapper select");
          $select_el.find("option:eq(0)").prop("selected", true);
          $select_el.niceSelect("update");
        }
      });

      for (let i = 0; i < app.productAddons.selectedProduct.length; i++) {
        if (app.productAddons.selectedProduct[i].product_id === productId)
          app.productAddons.selectedProduct.splice(i, 1);
      }
      app.productAddons.selectedVariant.splice(
        $.inArray(productId, app.productAddons.currentVariant),
        1
      );
      app.productAddons.totalValue -=
        parseFloat(
          app._formatMoney(removeProduct.variant_price).replace("$", "")
        ) * 100;
      product.selected = false;
    },

    _loadmore(event) {
      const $see_more_btn = $(event.currentTarget).closest("[see-more-btn]");
      const $next_btn_ele = $see_more_btn
        .parent()
        .prev("[data-search-pagination]")
        .find("[data-next-page]");
      const new_url = $next_btn_ele.prop("href");
      const total_pages = $next_btn_ele.attr("data-total-pages");
      let current_page = $next_btn_ele.attr("data-current-page");
      current_page = parseInt(current_page, 0) + 1;
      const next_page = parseInt(current_page, 0) + 1;
      $.ajax({
        type: "GET",
        url: new_url,
        beforeSend() {
          if ($("body #sitemap-page").length > 0) {
            $("#loader").show();
          } else {
            app.isLoading = true;
          }
        },
        success(response) {
          if (
            $("body #product-sitemap").length > 0 ||
            $("body #sitemap-page").length > 0
          ) {
            if (
              $(response).find(".feature-collection [show-all-apps-sitemap]")
                .length > 0
            ) {
              const new_data = $(response)
                .find(".feature-collection [show-all-apps-sitemap]")
                .html();
              if ($("body #sitemap-page").length > 0) {
                const $all_apps = $see_more_btn
                  .parent()
                  .parent()
                  .siblings("table")
                  .find("[show-all-apps]")
                  .append(new_data);
              } else {
                const $all_apps = $see_more_btn
                  .parent()
                  .parent()
                  .siblings("[show-all-apps]")
                  .append(new_data);
              }
              if (next_page <= total_pages) {
                $next_btn_ele.attr("data-current-page", current_page);
                $next_btn_ele.attr(
                  "href",
                  $next_btn_ele.attr("data-page-link") + next_page
                );
              }
              if (current_page === total_pages) {
                $see_more_btn.addClass("d-none");
              }
            }
          } else {
            if (
              $(response).find(".feature-collection [show-all-apps]").length > 0
            ) {
              // Appending more apps on collection page
              const new_data = $(response)
                .find(".feature-collection [show-all-apps]")
                .html();
              const $all_apps = $(".feature-collection [show-all-apps]").append(
                new_data
              );
            } else {
              // Appending more search resuls on search page
              const new_data = $(response)
                .find(".template-search [show-search-results]")
                .html();
              $(".template-search [show-search-results]").append(new_data);
            }
          }

          const new_search_url = $(response)
            .find("[data-search-pagination]")
            .html();
          $("[data-search-pagination] .pagination").replaceWith(new_search_url);
          app.isLoading = false;
          $("#loader").hide();
          if (
            $("[data-search-pagination]")
              .find("[data-next-page]")
              .hasClass("next-page")
          ) {
            $("[see-more-btn]").show();
          } else {
            $("[see-more-btn]").hide();
          }

          $(".template-search [search-see-more] [data-search-div]").each(
            function () {
              if ($.trim($(this).html()) === "") {
                $(this).remove();
              }
            }
          );
          // app.__readmoreless();
          app._setAllReviews();
        },
      });
    },

    _animateToSection(animate_ele, miuns_top, event) {
      let $animate_target;
      if (animate_ele !== "") {
        $animate_target = $(animate_ele);
      } else {
        $animate_target = $($(event.target).attr("href"));
      }
      $("html, body").animate(
        {
          scrollTop: $animate_target.offset().top - miuns_top,
        },
        1000
      );
    },

    _supportIndexingcontent(target, tab_indexing_target) {
      // Toggling the right side content while clicking on indexing
      $(".article-content").hide();
      $(`.article-content${target}`).toggle();

      // Adding active class to li in indexing
      $(".tab-indexing li").removeClass("active");
      tab_indexing_target.parent().addClass("active");
      tab_indexing_target
        .parent()
        .parents("ul")
        .parents("li")
        .addClass("active");

      // Toggling text classes to the a in indexing
      $(".tab-indexing a")
        .addClass("text-secondary")
        .removeClass("text-primary");
      tab_indexing_target
        .removeClass("text-secondary")
        .addClass("text-primary");

      // Appending the selected indexing title to breadcrumbs
      $(".breadcrumb-before").addClass("d-none");
      $(".breadcrumb-after").removeClass("d-none");
      $(".breadcrumb-after li.active").text(tab_indexing_target.text());

      // Change the position of helpful section at the end of the article content
      const $helpful_article = $(".helpful-article").detach();
      $(".article-tab-content .tab-content-list .helpful-section").append(
        $helpful_article
      );
      $(".helpful-article").removeClass("d-none");
    },

    __setDivSameHeight(tar_ele) {
      let maxHeight = 0;
      $(tar_ele).each(function () {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
        if ($(this).next('.card-footer').find('a.btn').hasClass('mt-md-5')) {
          $(this).next('.card-footer').find('a.btn').removeClass('mt-md-5');
        }
        if ($(this).next('.card-footer').find('a.btn').hasClass('mt-md-11')) {
          $(this).next('.card-footer').find('a.btn').removeClass('mt-md-11');
        }
        if ($(this).next('.card-footer').find('a.btn').hasClass('mt-md-12')) {
          $(this).next('.card-footer').find('a.btn').removeClass('mt-md-12');
        }
      });
      $(tar_ele).height(maxHeight);
    },

    _serviceProductLi(ul) {
      // Re-design the bullet points(except what's included/not included) with the tick marks for the service products
      $(ul).each(function (index, item) {
        if (
          $(this).parents(".includes").length <= 0 &&
          $(this).parents(".not-includes").length <= 0 &&
          !$(this)
            .prev()
            .text()
            .startsWith("Reasons to") &&
          $(this).parents("ul").length <= 0 &&
          ($(this).children('[class^="col-"]').lengh <= 0 ||
            $(this).children('[class^="col-"]') !== undefined) &&
          $(this)
            .find("li")
            .children('[class^="col-"]').length <= 0
        ) {
          $(this).addClass("list-unstyled");
          $(this)
            .find("li")
            .each(function (index_li, item_li) {
              const li_text = $(this).html();
              $(this).addClass("d-flex align-items-baseline");
              // if ($(this).find('br').length > 0) {
              $(this).html(`<div class="li-div">${li_text}</div>`);
              // } else {
              //   $(this).html('<div class="d-inline-flex align-items-center li-div">'+ li_text +'</div>');
              // }
              $(this)
                .find(".li-div")
                .before(
                  '<i class="ion ion-md-checkmark mr-2 text-18 text-hulkdarkpurple"></i>'
                );
              // $(this).find('.product-tooltip').html('<img src="https://cdn.shopify.com/s/files/1/1564/7647/files/info_d4767a77-6e16-4dda-95aa-87abb1923c3d.svg?v=1616502531" alt="Shopify - product-tooltip">');
              // $(this).find('.product-tooltip').removeClass('product-tooltip');
              if ($(this).find("ul").length > 0) {
                $(this).append($(this).find("ul"));
                $(this).addClass("flex-wrap");
                $(this)
                  .find("ul")
                  .addClass("pl-6");
                app._serviceProductLi($(this).find("ul"));
              }
            });
        }
      });
    },

    onCheckout(event) {
      // Start commented for store URL and pixel id
      event.preventDefault();
      event.stopPropagation();
      const update_fun_re = app.__updatePixelCartAttr();
      if (!update_fun_re) {
        return false;
      }
      const cartItemArray = [];
      $(app.cart.items).each((index, item) => {
        cartItemArray.push({
          id: item.product_id,
          name: item.product_title,
          sku: item.sku,
          price: item.final_line_price,
          variant: item.variant_title,
          quantity: item.quantity,
        });
      });
      dataLayer.push({
        // eslint-disable-next-line quote-props
        event: "checkout",
        // eslint-disable-next-line quote-props
        ecommerce: {
          // eslint-disable-next-line quote-props
          checkout: {
            // eslint-disable-next-line quote-props
            actionField: {
              // eslint-disable-next-line quote-props
              step: 1,
              // eslint-disable-next-line quote-props
              option: "Free delivery",
            },
            // eslint-disable-next-line quote-props
            products: cartItemArray,
          },
        },
        // eslint-disable-next-line quote-props
        eventCallback: function () {
          // Recharge code start
          // const recentItem = app.cart.items.find((x) => x.properties.shipping_interval_frequency > -1);
          // let checkout_url;
          // if (recentItem) {

          //   const paramCart = `&cart_token=${(document.cookie.match('(^|; )cart=([^;]*)') || 0)[2]}`;
          //   const shopifyDomain = 'hulkapps.myshopify.com';
          //   const paramDomain = `myshopify_domain=${shopifyDomain}`;
          //   let paramLinker;
          //   try {
          //     paramLinker = `&${ga.getAll()[0].get('linkerParam')}`;
          //   } catch (err) {
          //     paramLinker = '';
          //   }
          //   const paramCustomer = '{% if customer %}&customer_id={{ customer.id }}&customer_email={{ customer.email }}{% endif %}';
          //   checkout_url = `https://checkout.rechargeapps.com/r/checkout?${paramDomain}${paramCart}${paramLinker}`;
          // } else {
          //   checkout_url = '/checkout';
          // }
          // Recharge code end
          window.location = "/checkout";
        },
      });
    },

    __calendlyPopup(event, calendly_url) {
      event.preventDefault();
      Calendly.initPopupWidget({
        url: calendly_url,
      });
    },

    __updatePixelCartAttr() {
      let return_fun = true;
      let store_url = "";
      $("#text-store-error").remove();
      $("#text-theme-error").remove();
      if ($("#store-url").length > 0 && $("#store-url").val() === "") {
        $("#store-url")
          .parent()
          .after(
            '<p class="m-0 text-danger" id="text-store-error">Please Enter Store URL</p>'
          );
        return false;
        return_fun = false;
      } else {
        store_url = $("#store-url").val() + $("#post-url-text").text();
      }
      let theme_name = "";
      if ($("#theme-name").length > 0 && $("#theme-name").val() === "") {
        $("#theme-name").after(
          '<p class="m-0 text-danger" id="text-theme-error">Please Enter Theme Name</p>'
        );
        return false;
        return_fun = false;
      } else {
        theme_name = $("#theme-name").val();
      }
      let page_url = "";
      if ($("#page-url").length > 0 && $("#page-url").val() !== "") {
        page_url = $("#page-url").val();
      }
      let store_pwd = "";
      if ($("#store-pwd").length > 0 && $("#store-pwd").val() !== "") {
        store_pwd = $("#store-pwd").val();
      }
      let tag_id = "";
      if ($("#tag-id").length > 0 && $("#tag-id").val() !== "") {
        tag_id = $("#tag-id").val();
      }
      let type_id = "";
      if ($("#type-id").length > 0 && $("#type-id").val() !== "") {
        type_id = $("#type-id").val();
      }
      let c_id = "";
      if ($("#c-id").length > 0 && $("#c-id").val() !== "") {
        c_id = $("#c-id").val();
      }
      let google_ads_id = "";
      if ($("google-ads-id").length > 0 && $("google-ads-id").val() !== "") {
        google_ads_id = $("google-ads-id").val();
      }
      let google_ads_label = "";
      if (
        $("#google-ads-label").length > 0 &&
        $("#google-ads-label").val() !== ""
      ) {
        google_ads_label = $("#google-ads-label").val();
      }
      let adroll_pixel_id = "";
      if (
        $("#adroll-pixel-id").length > 0 &&
        $("#adroll-pixel-id").val() !== ""
      ) {
        adroll_pixel_id = $("#adroll-pixel-id").val();
      }
      let adroll_adv_id = "";
      if ($("#adroll-adv-id").length > 0 && $("#adroll-adv-id").val() !== "") {
        adroll_adv_id = $("#adroll-adv-id").val();
      }
      let doc_link = "";
      if ($("#doc-link").length > 0 && $("#doc-link").val() !== "") {
        doc_link = $("#doc-link").val();
      }
      let ref_links = "";
      if ($("#ref-links").length > 0 && $("#ref-links").val() !== "") {
        ref_links = $("#ref-links").val();
      }
      let description = "";
      if ($("#description").length > 0 && $("#description").val() !== "") {
        description = $("#description").val();
      }
      let taboola_id = "";
      if ($("#taboola-id").length > 0 && $("#taboola-id").val() !== "") {
        taboola_id = $("#taboola-id").val();
      }
      let shareasale_merchant_id = "";
      if (
        $("#shareasale-merchant-id").length > 0 &&
        $("#shareasale-merchant-id").val() !== ""
      ) {
        shareasale_merchant_id = $("#shareasale-merchant-id").val();
      }
      let criteo_id = "";
      if ($("#criteo-id").length > 0 && $("#criteo-id").val() !== "") {
        criteo_id = $("#criteo-id").val();
      }
      let outbrain_id = "";
      if ($("#outbrain-id").length > 0 && $("#outbrain-id").val() !== "") {
        outbrain_id = $("#outbrain-id").val();
      }
      let yahoo_gemini_id = "";
      if (
        $("#yahoo-gemini-id").length > 0 &&
        $("#yahoo-gemini-id").val() !== ""
      ) {
        yahoo_gemini_id = $("#yahoo-gemini-id").val();
      }
      let gtm_id = "";
      if ($("#gtm-id").length > 0 && $("#gtm-id").val() !== "") {
        gtm_id = $("#gtm-id").val();
      }
      let tiktok_id = "";
      if ($("#tiktok-id").length > 0 && $("#tiktok-id").val() !== "") {
        tiktok_id = $("#tiktok-id").val();
      }
      let pandora_id = "";
      if ($("#pandora-id").length > 0 && $("#pandora-id").val() !== "") {
        pandora_id = $("#pandora-id").val();
      }
      let amazon_attribution_id = "";
      if (
        $("#amazon-attribution-id").length > 0 &&
        $("#amazon-attribution-id").val() !== ""
      ) {
        amazon_attribution_id = $("#amazon-attribution-id").val();
      }
      let amazon_product_id = "";
      if (
        $("#amazon-product-id").length > 0 &&
        $("#amazon-product-id").val() !== ""
      ) {
        amazon_product_id = $("#amazon-product-id").val();
      }
      let adbeat_id = "";
      if ($("#adbeat-id").length > 0 && $("#adbeat-id").val() !== "") {
        adbeat_id = $("#adbeat-id").val();
      }
      let redirect_id = "";
      if ($("#redirect-id").length > 0 && $("#redirect-id").val() !== "") {
        redirect_id = $("#redirect-id").val();
      }
      let blackFire_id = "";
      if ($("#blackFire-id").length > 0 && $("#blackFire-id").val() !== "") {
        blackFire_id = $("#blackFire-id").val();
      }
      let comscore_id = "";
      if ($("#comscore-id").length > 0 && $("#comscore-id").val() !== "") {
        comscore_id = $("#comscore-id").val();
      }
      let rakuten_id = "";
      if ($("#rakuten-id").length > 0 && $("#rakuten-id").val() !== "") {
        rakuten_id = $("#rakuten-id").val();
      }
      let retention_science_id = "";
      if (
        $("#retention-science-id").length > 0 &&
        $("#retention-science-id").val() !== ""
      ) {
        retention_science_id = $("#retention-science-id").val();
      }
      let upsellit_id = "";
      if ($("#upsellit-id").length > 0 && $("#upsellit-id").val() !== "") {
        upsellit_id = $("#upsellit-id").val();
      }
      let gift_wizard_id = "";
      if (
        $("#gift-wizard-id").length > 0 &&
        $("#gift-wizard-id").val() !== ""
      ) {
        gift_wizard_id = $("#gift-wizard-id").val();
      }
      let olapic_id = "";
      if ($("#olapic-id").length > 0 && $("#olapic-id").val() !== "") {
        olapic_id = $("#olapic-id").val();
      }
      let yotpo_id = "";
      if ($("#yotpo-id").length > 0 && $("#yotpo-id").val() !== "") {
        yotpo_id = $("#yotpo-id").val();
      }
      let amazon_id = "";
      if ($("#amazon-id").length > 0 && $("#amazon-id").val() !== "") {
        amazon_id = $("#amazon-id").val();
      }
      let crazy_egg_id = "";
      if ($("#crazy-egg-id").length > 0 && $("#crazy-egg-id").val() !== "") {
        crazy_egg_id = $("#crazy-egg-id").val();
      }
      let source_knowledge_id = "";
      if (
        $("#source-knowledge-id").length > 0 &&
        $("#source-knowledge-id").val() !== ""
      ) {
        source_knowledge_id = $("#source-knowledge-id").val();
      }
      let juntuno_id = "";
      if ($("#juntuno-id").length > 0 && $("#juntuno-id").val() !== "") {
        juntuno_id = $("#juntuno-id").val();
      }
      let visual_iq_id = "";
      if ($("#visual-iq-id").length > 0 && $("#visual-iq-id").val() !== "") {
        visual_iq_id = $("#visual-iq-id").val();
      }
      let double_click_id = "";
      if (
        $("#double-click-id").length > 0 &&
        $("#double-click-id").val() !== ""
      ) {
        double_click_id = $("#double-click-id").val();
      }
      let google_analytics_id = "";
      if (
        $("#google-analytics-id").length > 0 &&
        $("#google-analytics-id").val() !== ""
      ) {
        google_analytics_id = $("#google-analytics-id").val();
      }
      let keynes_digital_id = "";
      if (
        $("#keynes-digital-id").length > 0 &&
        $("#keynes-digital-id").val() !== ""
      ) {
        keynes_digital_id = $("#keynes-digital-id").val();
      }
      let talkable_id = "";
      if ($("#talkable-id").length > 0 && $("#talkable-id").val() !== "") {
        talkable_id = $("#talkable-id").val();
      }
      let jumbleberry_merchant_id = "";
      if (
        $("#jumbleberry-merchant-id").length > 0 &&
        $("#jumbleberry-merchant-id").val() !== ""
      ) {
        jumbleberry_merchant_id = $("#jumbleberry-merchant-id").val();
      }
      let google_optimize_id = "";
      if (
        $("#google-optimize-id").length > 0 &&
        $("#google-optimize-id").val() !== ""
      ) {
        google_optimize_id = $("#google-optimize-id").val();
      }
      let reddit_id = "";
      if ($("#reddit-id").length > 0 && $("#reddit-id").val() !== "") {
        reddit_id = $("#reddit-id").val();
      }
      let quora_id = "";
      if ($("#quora-id").length > 0 && $("#quora-id").val() !== "") {
        quora_id = $("#quora-id").val();
      }
      let linkedin_id = "";
      if ($("#linkedin-id").length > 0 && $("#linkedin-id").val() !== "") {
        linkedin_id = $("#linkedin-id").val();
      }
      let twitter_id = "";
      if ($("#twitter-id").length > 0 && $("#twitter-id").val() !== "") {
        twitter_id = $("#twitter-id").val();
      }
      let pinterest_id = "";
      if ($("#pinterest-id").length > 0 && $("#pinterest-id").val() !== "") {
        pinterest_id = $("#pinterest-id").val();
      }
      let hotjar_id = "";
      if ($("#hotjar-id").length > 0 && $("#hotjar-id").val() !== "") {
        hotjar_id = $("#hotjar-id").val();
      }
      let facebook_id = "";
      if ($("#facebook-id").length > 0 && $("#facebook-id").val() !== "") {
        facebook_id = $("#facebook-id").val();
      }
      let bing_id = "";
      if ($("#bing-id").length > 0 && $("#bing-id").val() !== "") {
        bing_id = $("#bing-id").val();
      }
      let inuvo_id = "";
      if ($("#inuvo-id").length > 0 && $("#inuvo-id").val() !== "") {
        inuvo_id = $("#inuvo-id").val();
      }
      let avantlink_id = "";
      if ($("#avantlink-id").length > 0 && $("#avantlink-id").val() !== "") {
        avantlink_id = $("#avantlink-id").val();
      }
      let audiencex_id = "";
      if ($("#audiencex-id").length > 0 && $("#audiencex-id").val() !== "") {
        audiencex_id = $("#audiencex-id").val();
      }
      let hivewyre_id = "";
      if ($("#hivewyre-id").length > 0 && $("#hivewyre-id").val() !== "") {
        hivewyre_id = $("#hivewyre-id").val();
      }
      let power_inbox_id = "";
      if (
        $("#power-inbox-id").length > 0 &&
        $("#power-inbox-id").val() !== ""
      ) {
        power_inbox_id = $("#power-inbox-id").val();
      }
      let trust_pilot_id = "";
      if (
        $("#trust-pilot-id").length > 0 &&
        $("#trust-pilot-id").val() !== ""
      ) {
        trust_pilot_id = $("#trust-pilot-id").val();
      }
      let retargeter_id = "";
      if ($("#retargeter-id").length > 0 && $("#retargeter-id").val() !== "") {
        retargeter_id = $("#retargeter-id").val();
      }
      let bouncex_id = "";
      if ($("#bouncex-id").length > 0 && $("#bouncex-id").val() !== "") {
        bouncex_id = $("#bouncex-id").val();
      }
      let snapchat_id = "";
      if ($("#snapchat-id").length > 0 && $("#snapchat-id").val() !== "") {
        snapchat_id = $("#snapchat-id").val();
      }
      let awin_merchant_id = "";
      if (
        $("#awin-merchant-id").length > 0 &&
        $("#awin-merchant-id").val() !== ""
      ) {
        awin_merchant_id = $("#awin-merchant-id").val();
      }
      // console.log('called inder', store_url);
      const params_1 = {
        type: "POST",
        url: "/cart/update.js",
        data: {
          "attributes[Store URL]": store_url,
          "attributes[Theme Name]": theme_name,
          "attributes[Page URl]": page_url,
          "attributes[Storefront Password]": store_pwd,
          "attributes[Container Tag Id]": tag_id,
          "attributes[TypeID]": type_id,
          "attributes[CID]": c_id,
          "attributes[Google Ads Conversion ID]": google_ads_id,
          "attributes[Google Ads Conversion Lable]": google_ads_label,
          "attributes[Adroll Pixel ID]": adroll_pixel_id,
          "attributes[Adroll Adv Id]": adroll_adv_id,
          "attributes[Doc Link]": doc_link,
          "attributes[Reference Links]": ref_links,
          "attributes[Description]": description,
          "attributes[Taboola Pixel Id]": taboola_id,
          "attributes[ShareASale Merchant ID]": shareasale_merchant_id,
          "attributes[Criteo Pixel Id]": criteo_id,
          "attributes[OutBrain Pixel Id]": outbrain_id,
          "attributes[Yahoo/gemini Pixel Id]": yahoo_gemini_id,
          "attributes[Google Tag Manager Id]": gtm_id,
          "attributes[TikTok Pixel Id]": tiktok_id,
          "attributes[Pandora Pixel Id]": pandora_id,
          "attributes[Amazon Attribution Pixel Id]": amazon_attribution_id,
          "attributes[Amazon Product Targeting Pixel Id]": amazon_product_id,
          "attributes[Adbeat Pixel Id]": adbeat_id,
          "attributes[Redirect Pixel Id]": redirect_id,
          "attributes[BlackFire Pixel Id]": blackFire_id,
          "attributes[ComScore Pixel Id]": comscore_id,
          "attributes[Rakuten Pixel Id]": rakuten_id,
          "attributes[Retention Science]": retention_science_id,
          "attributes[UpSellit]": upsellit_id,
          "attributes[Gift Wizard Pixel ID]": gift_wizard_id,
          "attributes[Olapic Pixel ID]": olapic_id,
          "attributes[Yotpo Pixel ID]": yotpo_id,
          "attributes[Amazon Pixel ID]": amazon_id,
          "attributes[Crazy Egg Pixel ID]": crazy_egg_id,
          "attributes[Source Knowledge Pixel ID]": source_knowledge_id,
          "attributes[JuntUNO Pixel ID]": juntuno_id,
          "attributes[Visual IQ Pixel ID]": visual_iq_id,
          "attributes[Double Click ID]": double_click_id,
          "attributes[Google Analytics ID]": google_analytics_id,
          "attributes[Keynes Digital Pixel ID]": keynes_digital_id,
          "attributes[Talkable Pixel ID]": talkable_id,
          "attributes[Jumbleberry Merchant ID]": jumbleberry_merchant_id,
          "attributes[Google Optimize ID]": google_optimize_id,
          "attributes[Reddit Pixel ID]": reddit_id,
          "attributes[Quora Pixel ID]": quora_id,
          "attributes[Linkedin Pixel ID]": linkedin_id,
          "attributes[Twitter Pixel ID]": twitter_id,
          "attributes[Pinterest Pixel ID]": pinterest_id,
          "attributes[Hotjar Pixel ID]": hotjar_id,
          "attributes[Facebook Pixel ID]": facebook_id,
          "attributes[Bing Pixel ID]": bing_id,
          "attributes[Inuvo Pixel ID]": inuvo_id,
          "attributes[Avantlink Pixel ID]": avantlink_id,
          "attributes[AudienceX Pixel ID]": audiencex_id,
          "attributes[Hivewyre Pixel ID]": hivewyre_id,
          "attributes[Power Inbox Pixel ID]": power_inbox_id,
          "attributes[Trust Pilot Pixel ID]": trust_pilot_id,
          "attributes[Retargeter Pixel ID]": retargeter_id,
          "attributes[BounceX Pixel ID]": bouncex_id,
          "attributes[Snapchat Pixel ID]": snapchat_id,
          "attributes[AWIN Merchant ID]": awin_merchant_id,
        },
        success(response) {
          console.log("success store url and pixel id", response);
        },
        error(er) {
          const err = $.parseJSON(er.responseText);
          return false;
        },
      };
      $.ajax(params_1);
      return return_fun;
    },

    __modalPopup(e) {
      app.isCartDrawerOpen = false;
      const $youtube_ele = $(".youtube");
      const $video_popup_ele = $(".video-popup");
      if ($(e.target).closest(".cart-open-popup").length > 0) {
        app.__popupOpenClick();
        $(".cart-popup").addClass("opened");
      } else if ($(e.target).closest(".cart-close-popup").length > 0) {
        app.__popupCloseClick();
        $(".cart-popup").removeClass("opened");
      } else if ($(e.target).closest(".pricing-open-popup").length > 0) {
        e.preventDefault();
        app.__popupOpenClick();
        $(".pricing-popup").addClass("opened");
      } else if ($(e.target).closest(".pricing-close-popup").length > 0) {
        app.__popupCloseClick();
        $(".pricing-popup").removeClass("opened");
      } else if ($(e.target).closest(".video-open-popup").length > 0) {
        app.__popupOpenClick();
        $video_popup_ele.addClass("opened");

        if ($youtube_ele.length > 0) {
          const data_embed = $youtube_ele.attr("data-embed");
          // const data_embed_arr = data_embed.split('/');
          // const embed_id = data_embed_arr[data_embed_arr.length - 1];
          const iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("title", "App video");
          iframe.setAttribute(
            "src",
            `https://www.youtube.com/embed/${data_embed}?rel=0&showinfo=0&autoplay=1`
          );
          // $youtube_ele.parent().addClass('embed-responsive');
          $youtube_ele.innerHTML = "";
          $youtube_ele.append(iframe);
          // $youtube_ele.appendChild(iframe);
        }
        if (
          $("body")
            .find($video_popup_ele)
            .find(".video-wrap video").length > 0
        ) {
          $video_popup_ele
            .find(".video-wrap video")
            .get(0)
            .play();
          $video_popup_ele
            .find(".video-wrap video")
            .attr(
              "src",
              $video_popup_ele.find(".video-wrap video").attr("data-video-src")
            );
          $video_popup_ele
            .find(".video-wrap video source")
            .attr(
              "src",
              $video_popup_ele.find(".video-wrap video").attr("data-video-src")
            );
          // $video_popup_ele.find('.video-wrap video').autoplay = true;
        }
      } else if ($(e.target).closest(".video-close-popup").length > 0) {
        app.__popupCloseClick();
        $video_popup_ele.removeClass("opened");
        // To pause the youtube video
        if ($youtube_ele.length > 0) {
          $(".youtube iframe").remove();
        }
        // To pause the mp4 video
        if ($video_popup_ele.find(".video-wrap video").length > 0) {
          $video_popup_ele
            .find(".video-wrap video")
            .get(0)
            .pause();
          $video_popup_ele.find(".video-wrap video").attr("src", "");
          $video_popup_ele.find(".video-wrap video source").attr("src", "");
          // $video_popup_ele.find('.video-wrap video').autoplay = false;
        }
      } else if ($(e.target).closest(".gallery-open-popup").length > 0) {
        app.__popupOpenClick();
        $(".gallery-popup").addClass("opened");
      } else if ($(e.target).closest(".gallery-close-popup").length > 0) {
        app.__popupCloseClick();
        $(".gallery-popup").removeClass("opened");
      } else if ($(e.target).closest(".service-open-popup").length > 0) {
        app.__popupOpenClick();
        $(".service-popup").addClass("opened");
      } else if ($(e.target).closest(".service-close-popup").length > 0) {
        app.__popupCloseClick();
        $(".service-popup").removeClass("opened");
      }
    },

    __popupOpenClick() {
      app._lockScroll();
      app.isOverlayVisible = true;
      $("header").css("z-index", "999");
      $(".cart-drawer").css("z-index", "999");
    },

    __popupCloseClick() {
      app._unlockScroll();
      app.isOverlayVisible = false;
      $("header").removeAttr("style");
      $(".cart-drawer").removeAttr("style");
    },

    _countArticleVote() {
      // Calculating the total and helpful articles when clicked on yes/no
      let curr_url = window.location.href;
      $(".helpful-btn .vote-up").on("click", function () {
        const guide_center = $(".guide-center").attr("data-app-handle");
        $.getJSON(`https://api.countapi.xyz/info/hulkapps.com/${guide_center}`)
          .fail(() => {
            $.getJSON(
              `https://api.countapi.xyz/create?namespace=hulkapps.com&enable_reset=1&key=${guide_center}`,
              (response) => {
                console.log("Created", response);
              }
            );
          })
          .always(() => {
            $.getJSON(
              `https://api.countapi.xyz/update/hulkapps.com/${guide_center}?amount=1`,
              (response) => {
                console.log("Updated", response);
                $(this).addClass("active");
                $(this).css("pointer-events", "none");
              }
            );
          });
      });
    },

    __replaceWord() {
      $("p, h1, h2, h3, h4, h5, h6, span, a, div, li").each(function () {
        let curre_text = $(this);
        const match_wod = ['e-commerce', 'ecommerce', 'E-commerce', 'E-Commerce', 'E commerce', 'Ecommerce'];
        match_wod.forEach(function(item, index) {
          console.log('ite', item, curre_text.html())
          if(curre_text.html().indexOf(item) != -1) {
            console.log('called match');
            curre_text.html(curre_text.html().replaceAll(item, 'eCommerce'));
          }
        })
      });
    },

    __surveyArrowUpDown(up_target, down_target, index_target) {
      let total_step_div = $('.survey-page .survey-content .step').length - 1;
      up_target.removeClass('disabled');
      down_target.removeClass('disabled');
      if (index_target.index() == 1) {
        up_target.addClass('disabled');
      }
      if (index_target.index() == total_step_div) {
        down_target.addClass('disabled');
      }
    },

    __surveyArrowHideShow() {
      // Show/Hide next step's arrows
      if ($('.step:not(.d-none) .next-step').hasClass('d-none') == true) {
        $('.survey-page .survey-content .arrows').parent().addClass('d-none');
      } else {
        $('.survey-page .survey-content .arrows').parent().removeClass('d-none');
      }
    },

    __usecase(){
      var getUrl = app._getUrlParameter('use_case');
      
      // $('#tabs .nav-item').forEach((val) => {
      //   $(this).find('a').trigger()
      //   console.log('val----', val);
      // });
      $('.apps-use-case li').on('click',(event)=>{
        console.log(event.target)
        let id=event.target.id;
        let href=window.location.href.split('?use_cases=')[0]+`?use_cases=${id}`; 
        window.history.pushState('page2', 'Title', href);

      })


      $.each($('#tabs .nav-item'), (index, value) => {
        var href = $(value).find('a').attr('id');
        if (href === getUrl) {
          $(value).find('a')[0].click();
          console.log(href,'href')
        }
      });

    },
    __moveExtraFaq(){
      if($('.faq-extra').length > 0){
        let html = $('.faq-extra [data-compare]').detach();
        $('[data-add-faq] .col-lg-10 .row').append(html);
     
      }
    },
  },
};

export default customMethods;

// Brand logo slider
$(window).on("load", function () {
  // Please run it with window.onload, not with document.ready
  initSmoothScrolling(".brand-slider", "smoothscroll");
});

function initSmoothScrolling(container, animation) {
  /*
   * @param {String} container Class or ID of the animation container
   * @param {String} animation Name of the animation, e.g. smoothscroll
   */
  var sliderWidth = 0;
  var animationWidth = 0;
  var sliderHeight = $(".brand-logo-box:first-of-type", container).outerHeight(
    false
  );

  $(".brand-logo-box", container).each(function () {
    animationWidth += $(this).outerWidth(false);
  });

  // detect number of visible slides
  var slidesVisible =
    $(container).width() /
    $(".brand-logo-box:first-of-type", container).outerWidth(false);
  slidesVisible = Math.ceil(slidesVisible);

  // count slides to determine animation speed
  var slidesNumber = $(".brand-logo-box", container).length;
  var speed = slidesNumber * 3;

  // append the tail
  $(".brand-logo-box", container)
    .slice(0, slidesVisible)
    .clone()
    .appendTo($("#scroller", container));

  // Detect the slider width with appended tail
  $(".brand-logo-box", container).each(function () {
    sliderWidth += $(this).outerWidth(false);
  });

  // set slider dimensions
  $("#scroller", container).css({ width: sliderWidth, height: sliderHeight });

  // Insert styles to html
  $(
    "<style type='text/css'>@keyframes " +
    animation +
    " { 0% { margin-left: 0px; } 100% { margin-left: -" +
    animationWidth +
    "px; } } " +
    ".brand-slider .brand-logo-box:first-of-type" +
    " { -webkit-animation: " +
    animation +
    " " +
    speed +
    "s linear infinite; -moz-animation: " +
    animation +
    " " +
    speed +
    "s linear infinite; -ms-animation: " +
    animation +
    " " +
    speed +
    "s linear infinite; -o-animation: " +
    animation +
    " " +
    speed +
    "s linear infinite; animation: " +
    animation +
    " " +
    speed +
    "s linear infinite; }</style>"
  ).appendTo("head");

  // restart the animation (e.g. for safari & ie)
  var cl = $(container).attr("class");
  $(container)
    .removeClass(cl)
    .animate({ nothing: null }, 1, function () {
      $(this).addClass(cl);
    });
}
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".scrolltop").fadeIn();
    } else {
      $(".scrolltop").fadeOut();
    }
  });
  $(".scrolltop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
  $(".scrolltop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});
